var utils = require('./tripletrax.utils.js');
var validator = require('./tripletrax.validator.js');
var access = require('./tripletrax.access.js');
var patients = require('./tripletrax.patients.js');
var views = require('./tripletrax.views.js');
var changes = require('./tripletrax.changes.js');
var integrities = require('./tripletrax.integrities.js');
var monitoring = require('./tripletrax.monitoring.js');

function initializeElements(element, isOwnFacility, isLocked) {

    // Summernote Editor (muss vor den Tooltips erfolgen)
    initializeSummernote($(element).find('.summernote:not(.summernote-container)'));

    // activate tooltips
    $(element).find("[rel=tooltip]").each(function () {
        if (!utils.isUndefined($(this).data().containerTooltip)) {
			$(this).tooltip({ container: $(this).data().containerTooltip, trigger : 'hover' });
        } else {
			$(this).tooltip({ trigger : 'hover' });
		}
	});

    // activate popovers
    $(element).find("[rel=popover]").popover();

    if ($(element).find('.progress-bar').length) {
        $(element).find('.progress-bar').progressbar({
            display_text: 'fill'
        });
    }

    // activate popovers with hover states
    $(element).find("[rel=popover-hover]").popover({
        trigger: "hover"
    });

    setup_widgets_desktop(element);

    $(element).find('.dd:not(.dd-container)').each(function () {

        var element = $(this);

        var max_depth = $(this).data().depth;

        $(this).nestable({
            maxDepth: max_depth
        });

        var collapsed_level = element.data().collapsedLevel;
        if (collapsed_level !== '') {
            jQuery.each(element.find('li'), function (i, li) {
                if (li.hasAttribute('data-level') && $(li).attr('data-level') >= collapsed_level) {
                    element.nestable(['collapseItem', $(li)]);
                }
            });
        }

        element.addClass("dd-container");
    });

    $(element).find('.tt-treetable:not(.tree-container)').each(function () {

        var initial_state = $(this).data().treeInitialState;

        $(this).treetable({
            expandable: true,
            initialState: initial_state,
            indent: 15
        });

        $(this).addClass("tree-container");
    });

	// muss nach der Initialisierung der Datatables kommen
	// initializeSelect2($(element).find('.tt-select2:not(.select2-container)'));

	// Muss vor der Initialisierung des Timepickers kommen
	validator.setValidationToForms(element);

	initializeDatepicker($(element).find('.datepicker:not(.datepicker-container)'));

	$(element).find('.timepicker:not(.timepicker-container)').each(function () {

		$(this).timepicker({
			minuteStep: 1,
			showMeridian: false,
			defaultTime: '00:00:00'
		});

		$(this).addClass("timepicker-container");
	});

    // Minimale Höhe der linken Tab Navigation speichern
    $(element).find('.tt-nav-tabs:not(.tt-nav-tab-container)').each(function () {

        $(this).attr("data-min-height", $(this).height());
        $(this).addClass("tt-nav-tab-container");
    });

    $(element).find('.tt-check-changes-form').each(function () {
        $(this).areYouSure({'silent': true});
    });

    var handle_ajax_error = function (error) {
        if (error.status == "401") {
            location.reload();
        } else {
            utils.setHtmlData($("#content"), error.responseText, false);
        }
    };

    $(element).find('.tt-datatable:not(.datatable-container)').each(function () {

        var element = $(this);

        var dom = "t";
		if (element[0].id === "table_role_rights") {
			dom = "tr";
		} else if (element[0].id === "table_stats_visits") {
            dom = '<"wrapper"it>';
        }

        var scroll = "";
        //if (element[0].id === "table_role_rights") {
        //  scroll = parseInt($(this)[0].getAttribute('data-table-scroll'));
        //}

        var sort = true;
        if (element[0].id === "table_role_rights" || element[0].id === "table_mails" || element[0].id === "table_roles_overview") {
            sort = false;
        }

        var orderType = "asc";
        if (!utils.isUndefined(element[0].getAttribute('data-table-default-order-type'))) {
            orderType = element[0].getAttribute('data-table-default-order-type');
        }

        var zeroRecordsText = Lang.get('tripletrax.no_data_found');
        if (!utils.isUndefined(element[0].getAttribute('data-table-zero-records-text'))) {
            zeroRecordsText = element[0].getAttribute('data-table-zero-records-text');
        }

        var ajax_url = $(this)[0].getAttribute('data-table-url') + "/datatable";
        if (element[0].id === "table_role_rights") {
            var id = 0;
            var row = $('#table_roles').dataTable().$('tr.selected-row');
            if ($(row).length > 0) {
                id = row[0].id
            }
            ajax_url = $(this)[0].getAttribute('data-table-url') + "/datatable/" + id;
        } else if (element[0].id === "table_mails") {
            ajax_url = $(this)[0].getAttribute('data-table-url')
        } else if (element[0].id === "table_roles_overview") {
            ajax_url = $(this)[0].getAttribute('data-table-url')
        }

        var doInitializeElements = true;
        if (element[0].id === "table_role_rights" || element[0].id === "table_roles_overview") {
            doInitializeElements = false;
        }

        var columnDefinitions = [
            {
                targets: [0],
                visible: false,
                searchable: false
            }
        ];

        if (element[0].id === "table_users") {
            columnDefinitions = [
                {
                    targets: 0,
                    data: 'id_internal',
                    visible: false,
                    searchable: false
                },
                {
                    targets: 1,
                    data: 'id',
                    visible: false,
                    searchable: false
                },
                {
                    targets: 2,
                    data: 'username',
                    render: function (data, type, full, meta) {
                        if (full['locked'] === 1 || full['locked'] === "1") {
                            return data + '&nbsp;&nbsp;<i class="fad fa-lock"></i>';
                        }
                        return data;
                    }
                },
                {
                    targets: 3,
                    data: 'firstname'
                },
                {
                    targets: 4,
                    data: 'name'
                },
                {
                    targets: 5,
                    data: 'facilities'
                },
                {
                    targets: 6,
                    data: 'locked',
                    visible: false,
                    searchable: false
                }
            ];
        } else if (element[0].id === "table_agreement_list") {
            columnDefinitions = [
                {
                    targets: [0, 8, 9, 10, 11],
                    visible: false,
                    searchable: false
                },
                {
                    targets: [5, 6],
                    render: function (data, type, full, meta) {
                        return utils.dateToLocaleString(data);
                    }
                },
                {
                    targets: 7,
                    render: function (data, type, full, meta) {
                        if (!utils.isUndefined(full[8]) && full[8] !== '') {
                            return $('#state_values').data().values[full[8]];
                        } else {
                            return data;
                        }
                    }
                }
            ];
        } else if (element[0].id === "table_data_collection_types") {
            columnDefinitions = [
                {
                    targets: [0],
                    visible: false,
                    searchable: false
                },
                {
                    targets: [3],
                    render: function (data, type, full, meta) {
                        return Lang.get('tripletrax.' + full[3]);
                    }
                }
            ];
        } else if (element[0].id === "table_agreement_types") {
            columnDefinitions = [
                {
                    targets: [0, 5],
                    visible: false,
                    searchable: false
                },
                {
                    targets: [3, 4],
                    render: function (data, type, full, meta) {
                        return utils.dateToLocaleString(data);
                    }
                }
            ];
        } else if (element[0].id === "table_role_rights") {
            var rightClass = '';
            if (element.hasClass('tt-right-datatable-write')) {
                rightClass = 'tt-right-checkbox-write';
            } else if (element.hasClass('tt-right-datatable-update')) {
                rightClass = 'tt-right-checkbox-update';
            }

            columnDefinitions = [
                {
                    targets: [0],
                    render: function (data, type, full, meta) {
                        if (full[14] === "default_role_rights" || full[14] === "default_monitoring_type_role_rights" || full[14] === "monitoring_types") {
                            if (Lang.get('tripletrax.' + data).match("^tripletrax.")) {
                                return data;
                            } else {
                                return Lang.get('tripletrax.' + data);
                            }
                        } else if (full[14] == "data_collection_types") {
                            return data;
                        } else {
                            return data + ' (' + Lang.get('tripletrax.data_views_' + full[16]) + ')';
                        }
                    }
                },
                {
                    targets: [1],
                    render: function (data, type, full, meta) {
                        if (full[18] === '' || jQuery.inArray('all_rights', full[18].split(',')) > -1) {
                            if (data === '1' || data === 1) {
                                return '<label id="right_all_rights" class="checkbox tt-checkbox-datatable"><input name="all_rights" type="checkbox" class="' + rightClass + '" checked><i></i></label>';
                            } else {
                                return '<label id="right_all_rights" class="checkbox tt-checkbox-datatable"><input name="all_rights" type="checkbox" class="' + rightClass + '"><i></i></label>';
                            }
                        } else {
                            return '<i class="fad fa-minus tt-not-available"></i>';
                        }
                    }
                },
                {
                    targets: [2],
                    render: function (data, type, full, meta) {
                        if (full[18] === '' || jQuery.inArray('read', full[18].split(',')) > -1) {
                            if (data === '1' || data === 1) {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="read" type="checkbox" class="' + rightClass + '" checked><i></i></label>';
                            } else {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="read" type="checkbox" class="' + rightClass + '"><i></i></label>';
                            }
                        } else {
                            return '<i class="fad fa-minus tt-not-available"></i>';
                        }
                    }
                },
                {
                    targets: [3],
                    render: function (data, type, full, meta) {
                        if (full[18] === '' || jQuery.inArray('write', full[18].split(',')) > -1) {
                            if (data === '1' || data === 1) {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="write" type="checkbox" class="' + rightClass + '" checked><i></i></label>';
                            } else {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="write" type="checkbox" class="' + rightClass + '"><i></i></label>';
                            }
                        } else {
                            return '<i class="fad fa-minus tt-not-available"></i>';
                        }
                    }
                },
                {
                    targets: [4],
                    render: function (data, type, full, meta) {
                        if (full[18] === '' || jQuery.inArray('update', full[18].split(',')) > -1) {
                            if (data === '1' || data === 1) {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="update" type="checkbox" class="' + rightClass + '" checked><i></i></label>';
                            } else {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="update" type="checkbox" class="' + rightClass + '"><i></i></label>';
                            }
                        } else {
                            return '<i class="fad fa-minus tt-not-available"></i>';
                        }
                    }
                },
                {
                    targets: [5],
                    render: function (data, type, full, meta) {
                        if (full[18] === '' || jQuery.inArray('delete', full[18].split(',')) > -1) {
                            if (data === '1' || data === 1) {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="delete" type="checkbox" class="' + rightClass + '" checked><i></i></label>';
                            } else {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="delete" type="checkbox" class="' + rightClass + '"><i></i></label>';
                            }
                        } else {
                            return '<i class="fad fa-minus tt-not-available"></i>';
                        }
                    }
                },
                {
                    targets: [6],
                    render: function (data, type, full, meta) {
                        if (full[18] === '' || jQuery.inArray('export', full[18].split(',')) > -1) {
                            if (data === '1' || data === 1) {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="export" type="checkbox" class="' + rightClass + '" checked><i></i></label>';
                            } else {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="export" type="checkbox" class="' + rightClass + '"><i></i></label>';
                            }
                        } else {
                            return '<i class="fad fa-minus tt-not-available"></i>';
                        }
                    }
                },
                {
                    targets: [7],
                    render: function (data, type, full, meta) {
                        if (full[18] === '' || jQuery.inArray('audittrail', full[18].split(',')) > -1) {
                            if (data === '1' || data === 1) {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="audittrail" type="checkbox" class="' + rightClass + '" checked><i></i></label>';
                            } else {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="audittrail" type="checkbox" class="' + rightClass + '"><i></i></label>';
                            }
                        } else {
                            return '<i class="fad fa-minus tt-not-available"></i>';
                        }
                    }
                },
                {
                    targets: [8],
                    render: function (data, type, full, meta) {
                        if (full[18] === '' || jQuery.inArray('create_query', full[18].split(',')) > -1) {
                            if (data === '1' || data === 1) {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="create_query" type="checkbox" class="' + rightClass + '" checked><i></i></label>';
                            } else {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="create_query" type="checkbox" class="' + rightClass + '"><i></i></label>';
                            }
                        } else {
                            return '<i class="fad fa-minus tt-not-available"></i>';
                        }
                    }
                },
                {
                    targets: [9],
                    render: function (data, type, full, meta) {
                        if (full[18] === '' || jQuery.inArray('answer_query', full[18].split(',')) > -1) {
                            if (data === '1' || data === 1) {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="answer_query" type="checkbox" class="' + rightClass + '" checked><i></i></label>';
                            } else {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="answer_query" type="checkbox" class="' + rightClass + '"><i></i></label>';
                            }
                        } else {
                            return '<i class="fad fa-minus tt-not-available"></i>';
                        }
                    }
                },
                {
                    targets: [10],
                    render: function (data, type, full, meta) {
                        if (full[18] === '' || jQuery.inArray('close_query', full[18].split(',')) > -1) {
                            if (data === '1' || data === 1) {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="close_query" type="checkbox" class="' + rightClass + '" checked><i></i></label>';
                            } else {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="close_query" type="checkbox" class="' + rightClass + '"><i></i></label>';
                            }
                        } else {
                            return '<i class="fad fa-minus tt-not-available"></i>';
                        }
                    }
                },
                {
                    targets: [11],
                    render: function (data, type, full, meta) {
                        if (full[18] === '' || jQuery.inArray('delete_query', full[18].split(',')) > -1) {
                            if (data === '1' || data === 1) {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="delete_query" type="checkbox" class="' + rightClass + '" checked><i></i></label>';
                            } else {
                                return '<label class="checkbox tt-checkbox-datatable"><input name="delete_query" type="checkbox" class="' + rightClass + '"><i></i></label>';
                            }
                        } else {
                            return '<i class="fad fa-minus tt-not-available"></i>';
                        }
                    }
                },
                {
                    targets: [12, 13, 14, 15, 16, 17, 18, 19, 20],
                    visible: false,
                    searchable: false
                }
            ];
        } else if (element[0].id === "table_news") {
            columnDefinitions = [
                {
                    targets: [0],
                    visible: false,
                    searchable: false
                },
                {
                    targets: [2, 3],
                    render: function (data, type, full, meta) {
                        return utils.dateToLocaleString(data);
                    }
                }
            ];
        } else if (element[0].id === "table_documents") {
            columnDefinitions = [
                {
                    targets: [0],
                    visible: false,
                    searchable: false
                },
                {
                    targets: [2],
                    render: function (data, type, full, meta) {
                        return trans('tripletrax.' + data);
                    },
                    searchable: false
                },
                {
                    targets: [3, 4],
                    render: function (data, type, full, meta) {
                        return utils.dateToLocaleString(data);
                    }
                }
            ];
        } else if (element[0].id === "table_mails") {
            columnDefinitions = [
                {
                    targets: [0],
                    visible: false,
                    searchable: false
                },
                {
                    targets: [1],
                    searchable: false,
                    render: function (data, type, full, meta) {
                        if (type === 'display') {
                            var checked = '';
                            if (data === 1) {
                                checked = 'checked';
                            }
                            return '<div class="checkbox smart-form">' +
                                '<label class="">' +
                                '<input class="checkbox style-1" type="checkbox" ' + checked + '>' +
                                '<span></span> </label>' +
                            '</div>';
                        }
                        return '';
                    }
                },
                {
                    targets: [2],
                    searchable: false,
                    render: function (data, type, full, meta) {
                        if (type === 'display') {
                            if (full[2] === full[3]) {
                                return '<div>' +
                                    full[2] +
                                    '</div>';
                            }
                            return '<div>' +
                                full[3] + " " + full[2] +
                                '</div>';
                        }
                        return full[3] + " " + full[2];
                    }
                },
                {
                    targets: [3],
                    searchable: false,
                    render: function (data, type, full, meta) {
                        if (type === 'display') {
                            return '<div class="tt-mail-text">' +
                                '<span> ' + full[4] + '</span> ' + $('<p>' + full[5] + '</p>').text().replace('&', '&amp;').replace('<', '&lt;').replace('>', '&gt;') +
                                '</div>';
                        }
                        return full[4] + " " + full[5];
                    }
                },
                {
                    targets: [4],
                    searchable: false,
                    render: function (data, type, full, meta) {
                        if (type === 'display') {
                            var attachments = '';
                            if (full[8] > 0) {
                                attachments = '<i class="fad fa-paperclip fa-lg"></i>';
                            }
                            return '<div>' +
                                attachments +
                                '</div>';
                        }
                        return full[8];
                    }
                },
                {
                    targets: [5],
                    searchable: false,
                    render: function (data, type, full, meta) {
                        if (type === 'display') {
                            return '<div>' +
                                    utils.dateToLocaleTimeString(full[6]) +
                                '</div>';
                        }
                        return full[6];
                    }
                }
            ];
        } else if (element[0].id === "table_doc_documents") {
            columnDefinitions = [
                {
                    targets: [0],
                    visible: false,
                    searchable: false
                },
                {
                    targets: [1],
                    width: '15%'
                },
                {
                    targets: [2],
                    width: '45%'
                },
                {
                    targets: [3],
                    width: '30%',
                    searchable: false,
                    render: function (data, type, full, meta) {
                        if (full[3] !== '') {
                            return '<a class="tt-documents-show-url" href="' + full[3] + '">' + full[3] + '</a>'
                        }
                        return '';
                    }
                },
                {
                    targets: [4],
                    width: '5%',
                    searchable: false,
                    render: function (data, type, full, meta) {
                        if (full[4] !== '') {
                            return '<a class="tt-documents-show-file tt-show-document" href="' + full[5] + '"><i class="fad fa-eye fa-lg"></i></a>'
                        }
                        return '';
                    }
                },
                {
                    targets: [5],
                    width: '5%',
                    searchable: false,
                    render: function (data, type, full, meta) {
                        if (full[5] !== '') {
                            return '<a class="tt-documents-print-file tt-print-document" href="' + full[5] + '"><i class="fad fa-print fa-lg"></i></a>'
                        }
                        return '';
                    }
                }
            ];
        } else if (element[0].id === "table_stats_visits") {
            columnDefinitions = [
                {
                    targets: 0,
                    sortable: false,
                    visible: false,
                    data: "id"
                },
                {
                    targets: 1,
                    sortable: false,
                    data: "client_ip"
                },
                {
                    targets: 2,
                    sortable: false,
                    data: "hostname"
                },
                {
                    targets: 3,
                    sortable: false,
                    data: "country"
                },
                {
                    targets: 4,
                    sortable: false,
                    data: "user"
                },
                {
                    targets: 5,
                    sortable: false,
                    data: "device"
                },
                {
                    targets: 6,
                    sortable: false,
                    data: "browser"
                },
                {
                    targets: 7,
                    sortable: false,
                    data: "language"
                },
                {
                    targets: 8,
                    sortable: false,
                    data: "lastActivity"
                }
            ];
        } else if (element[0].id === "table_roles_overview") {
            columnDefinitions = [
                {
                    targets: [1, 2, 3],
                    visible: false,
                    searchable: false
                }
            ];
        } else if (element[0].id === "table_export_history") {
            columnDefinitions = [
                {
                    targets: [0],
                    visible: false,
                    searchable: false
                },
                {
                    targets: [2],
                    render: function (data, type, full, meta) {
                        if (type === 'display') {
                            return utils.dateToLocaleTimeString(data);
                        }
                        return data;
                    }
                },
                {
                    targets: [3],
                    render: function (data, type, full, meta) {
                        if (data !== '') {
                            return trans('tripletrax.export_reason_' + data);
                        }
                        return data;
                    }
                }
            ];
        } else if (element[0].id === "table_devices") {
			columnDefinitions = [
				{
					targets: [0, 2],
					visible: false,
					sortable: false
				},
				{
					targets: [1],
					render: function (data, type, full, meta) {
						if (full[2] === 1 || full[2] === "1") {
							return data + '&nbsp;&nbsp;<i class="fad fa-lock"></i>';
						}
						return data;
					}
				}
			];
		} else if (element[0].id === "table_system_events") {
				columnDefinitions = [
					{
						targets: 0,
                        data: 'id',
						visible: false,
						searchable: false
					},
					{
						targets: 1,
                        data: 'created_at',
						render: function (data, type, full, meta) {
							if (type === 'display') {
								return utils.dateToLocaleTimeString(data);
							}
							return data;
						}
					},
                    {
                        targets: 2,
                        data: 'type'
                    },
					{
						targets: 3,
                        data: 'event',
						render: function (data, type, full, meta) {
							if (data !== '') {
								return trans('tripletrax.' + data.toLowerCase());
							}
							return data;
						}
					},
                    {
                        targets: 4,
                        data: 'result',
                        render: function (data, type, full, meta) {
                            if (data !== '') {
                                return trans('tripletrax.' + data.toLowerCase());
                            }
                            return data;
                        }
                    },
					{
						targets: 5,
                        data: 'result_text',
						render: function (data, type, full, meta) {
							if (type === 'display') {
								var rCRLF = /\r?\n/g;
								return data.replace(rCRLF, '<br>');
							}
							return data;
						}
					},
					{
						targets: 6,
                        data: 'file_path',
						render: function (data, type, full, meta) {
							if (type === 'display') {
								return data.substr(data.lastIndexOf('/') + 1);
							}
							return data;
						}
					},
                    {
                        targets: 7,
                        data: 'last_user'
                    }
				];
        } else if (element[0].id === "table_monitoring") {
            columnDefinitions = [
                {
                    targets: 0,
                    data: 'id',
                    visible: false,
                    searchable: false
                },
                {
                    targets: 1,
                    data: 'description'
                },
                {
                    targets: 2,
                    data: 'data_collection_types'
                }
            ];
        } else if (element[0].id === "table_facilities") {
            columnDefinitions = [
                {
                    targets: 0,
                    data: 'id_internal',
                    visible: false,
                    searchable: false
                },
                {
                    targets: 1,
                    data: 'facilityid'
                },
                {
                    targets: 2,
                    data: 'facilityname'
                },
                {
                    targets: 3,
                    data: 'facilitycity'
                },
                {
                    targets: 4,
                    data: 'medical_contact'
                },
                {
                    targets: 5,
                    data: 'technical_contact'
                }
            ];
		} else if (element[0].id === "table_freeze_facility_data") {
            columnDefinitions = [
                {
                    targets: 0,
                    data: 'id_internal',
                    visible: false,
                    searchable: false
                },
                {
                    targets: 1,
                    data: 'facilityid'
                },
                {
                    targets: 2,
                    data: 'facilityname'
                },
                {
                    targets: 3,
                    data: 'locked_periods',
                    render: function (data, type, full, meta) {
                        if (type === 'display') {
                            if (utils.isUndefined(data)) {
                                return '';
                            } else {
                                var periods = data.split('|');
                                if (periods.length === 1) {
                                    return utils.dateToLocaleString(data.split(',')[0]) + ' - ' + utils.dateToLocaleString(data.split(',')[1]);
                                } else {
                                    var displayValue = '';
                                    var fromDate = moment(periods[0].split(',')[0]);
                                    var tillDate = moment(periods[0].split(',')[1]);
                                    jQuery.each(periods, function (i, period) {
                                        if (i > 0) {
                                            var currentFromDate = moment(period.split(',')[0]);
                                            var tillDateAddedDay = tillDate.clone().add(1, 'd');
                                            if (utils.dateToLocaleString(tillDateAddedDay) === utils.dateToLocaleString(currentFromDate)) {
                                                tillDate = moment(period.split(',')[1]);
                                                if (i === periods.length - 1) {
                                                    if (displayValue !== '') {
                                                        displayValue += '<br>';
                                                    }
                                                    displayValue += utils.dateToLocaleString(fromDate) + ' - ' + utils.dateToLocaleString(tillDate);
                                                }
                                            } else {
                                                if (displayValue !== '') {
                                                    displayValue += '<br>';
                                                }
                                                displayValue += utils.dateToLocaleString(fromDate) + ' - ' + utils.dateToLocaleString(tillDate);
                                                fromDate = moment(period.split(',')[0]);
                                                tillDate = moment(period.split(',')[1]);
                                                if (i === periods.length - 1) {
                                                    if (displayValue !== '') {
                                                        displayValue += '<br>';
                                                    }
                                                    displayValue += utils.dateToLocaleString(fromDate) + ' - ' + utils.dateToLocaleString(tillDate);
                                                }
                                            }
                                        }
                                    });

                                    return displayValue;
                                }
                            }
                        }
                        return data;
                    }
                },
                {
                    targets: 4,
                    data: 'locked_patients'
                }
            ];
        }

        $(this).dataTable({
            processing: true,
            serverSide: true,
            paging: true,
            sort: sort,
            scrollY: scroll,
            scroller: {
                loadingIndicator: true
            },
            info: true,
            autoWidth: false,
            deferRender: true,
            pageLength: parseInt($(this)[0].getAttribute('data-table-page-length')),
            order: [[parseInt($(this)[0].getAttribute('data-table-default-order-column')), orderType]],
            language: {
                zeroRecords: zeroRecordsText,
                processing: '<h1><i class="fad fa-cog fa-spin"></i> ' + Lang.get('tripletrax.loading') + '...</h1>',
                info: Lang.get('tripletrax.table_info_entries'),
                infoEmpty: Lang.get('tripletrax.no_records_available'),
                decimal: utils.getDecimalSeparator(),
                thousands: utils.getDecimalSeparator() === ',' ? '.' : ','
            },
            dom: dom,
            columnDefs: columnDefinitions,
            ajax: {
                url: ajax_url,
                error: handle_ajax_error,
                data: function (d) {
                    if (element[0].id === "table_stats_visits") {
                        var filterBrowser = '';
                        if ($('[name="filter_browser"]').hasClass('select2-container')) {
                            filterBrowser = $('[name="filter_browser"]').select2('val');
                        }
                        var filterUser = '';
                        if ($('[name="filter_user"]').hasClass('select2-container')) {
                            filterUser = $('[name="filter_user"]').select2('val');
                        }

                        return $.extend({}, d, {
                            'filter_browser': filterBrowser,
                            'filter_user': filterUser
                        });
                    }
                    return d;
                }
            },
            drawCallback: function (settings) {
                if ($(this)[0].id !== "table_role_rights" && $(this)[0].id !== "table_roles_overview" && $(this)[0].id !== "table_monitoring_patientlist" && !/^table_monitoring_custom_/.test($(this)[0].id)) {
                    setPaginateButtons($(this), settings, false);
                }
                if ($(this)[0].id === "table_role_rights" || $(this)[0].id === "table_roles_overview") {
                    var initial_state = $(this).data().treeInitialState;

                    $(this).treetable({
                        expandable: true,
                        initialState: initial_state
                    }, true);

                    if ($(this)[0].id === "table_role_rights") {

                        access.setControlsDependingOnRights($(this).parents('.tt-content-detail'), true, false);

                        // Alle Controls, welche innerhalb einer Gruppe mit RadioButtons sind, inaktiv setzen (diese haben immer das gleiche Recht wie die Gruppe)
                        var counter = 0;
                        $.each($(this).find('tr'), function (i, row) {

                            if (!utils.isUndefined(row.dataset) && !utils.isUndefined(row.dataset.ttControlType) && row.dataset.ttControlType === 'group_with_radio') {

                                var ids = row.id.split('|');
                                var aCurrentPos = counter;
                                var aPos = counter;
                                var tr = $(row).parents('.tt-datatable,.tt-datatable-dialog').find('tbody tr').eq(aPos);

                                while ((tr.length > 0 && tr[0].id.split('|')[1] !== ids[1] && parseInt(tr[0].id.split('|')[1]) > parseInt(ids[1])) || aPos === aCurrentPos) {

                                    jQuery.each(tr.find('[type="checkbox"]'), function (i, val) {
                                        $(val).prop('disabled', 'disabled');
                                    });

                                    aPos = aPos + 1;
                                    tr = $(row).parents('.tt-datatable,.tt-datatable-dialog').find('tbody tr').eq(aPos);
                                }
                            }

                            counter++;
                        });
                    }
                }
            },
            rowCallback: function (row, data, displayIndex) {
                if (utils.isUndefined(data[0])) {
                    row.id = data['id'];
                } else {
                    row.id = data[0];
                }

                if (row.id == $('#content-detail').find('.tt-selected-id').val()) {
                    $(row).addClass('selected-row');
                }
                if ($(this)[0].id === "table_users") {
                    if (data['locked'] === 1 || data['locked'] === "1") {
                        $('td', row).addClass('locked');
                    }
                } else if ($(this)[0].id === "table_role_rights") {
                    $(row).attr('id', data[13] + '|' + data[15]);
                    $(row).attr('data-tt-control-type', data[16]);
                    $(row).attr('data-tt-level', data[20]);
                    if (data[14] === "data_views") {
                        $(row).attr('data-tt-id', 'dv_' + data[13]);
                    } else if (data[14] === "data_collection_types") {
                        $(row).attr('data-tt-id', 'dct_' + data[13]);
                    } else if (data[14] === "default_monitoring_type_role_rights") {
                        $(row).attr('data-tt-id', 'dmtrr_' + data[13]);
                    } else if (data[14] === "monitoring_types") {
                        $(row).attr('data-tt-id', 'mt_' + data[13]);
                    } else {
                        $(row).attr('data-tt-id', 'drr_' + data[13]);
                    }
                    if (data[15] > 0) {
                        if (data[14] === "data_views") {
                            $(row).attr('data-tt-parent-id', 'dv_' + data[15]);
                        } else if (data[14] === "data_collection_types") {
                            $(row).attr('data-tt-parent-id', 'ddctrr_' + data[15]);
                        } else if (data[14] === "monitoring_types" || data[14] === "default_monitoring_type_role_rights") {
                            $(row).attr('data-tt-parent-id', 'dmtrr_' + data[15]);
                        } else {
                            $(row).attr('data-tt-parent-id', 'drr_' + data[15]);
                        }
                    }
                } else if($(this)[0].id === "table_mails") {
                    $($(row).find('td')[0]).addClass('inbox-table-icon tt-selection-column');
                    $($(row).find('td')[1]).addClass('inbox-data-from hidden-xs hidden-sm');
                    $($(row).find('td')[2]).addClass('inbox-data-message');
                    $($(row).find('td')[3]).addClass('inbox-data-attachment hidden-xs');
                    $($(row).find('td')[4]).addClass('inbox-data-date hidden-xs');
                    if (!data[7]) {
                        $(row).addClass('unread');
                    }
                    if ($.inArray(data[0], utils.GLOBALS.mailsUnselected) >= 0) {
                        $($(row).find('td')[0]).find('input[type="checkbox"]').prop('checked', false);
                    } else if ($.inArray(data[0], utils.GLOBALS.mailsSelected) >= 0) {
                        $($(row).find('td')[0]).find('input[type="checkbox"]').prop('checked', true);
                    }
                } else if ($(this)[0].id === "table_roles_overview") {
                    if (!utils.isUndefined(data[3])) {
                        $(row).attr('data-tt-id', data[1] + '-' + data[2] + '-' + data[3]);
                        $(row).attr('data-tt-parent-id', data[1] + '-' + data[2]);
                    } else if (!utils.isUndefined(data[2])) {
                        $(row).attr('data-tt-id', data[1] + '-' + data[2]);
                        $(row).attr('data-tt-parent-id', data[1].toString());
                    } else {
                        $(row).attr('data-tt-id', data[1].toString());
                    }
                } else if ($(this)[0].id === "table_doc_documents") {
                    $($(row).find('td')[1]).addClass('tt-documents-description-column');
                } else if ($(this)[0].id === "table_devices") {
					if (data[2] === 1 || data[2] === "1") {
						$('td', row).addClass('locked');
					}
				} else if ($(this)[0].id === "table_system_events") {
					$('td', row).addClass('tt-' + data['result'].toLowerCase());
				}
            },
            initComplete: function (settings, json) {
                $(this).addClass("datatable-container");

                if ($(this)[0].id === "table_role_rights" || $(this)[0].id === "table_roles_overview") {
                    var initial_state = $(this).data().treeInitialState;

                    $(this).treetable({
                        expandable: true,
                        initialState: initial_state
                    });

                    $(this).addClass("tree-container");
                }
            },
        });
    });

    $(element).find('.tt-datatable-detail:not(.datatable-container),.tt-datatable-dialog:not(.datatable-container)').each(function () {

        var element = $(this);

        var sort = true;
        if ($(element[0]).hasClass('tt-not-sortable')) {
            sort = false;
        }

        var orderType = "asc";
        if (!utils.isUndefined(element[0].getAttribute('data-table-default-order-type'))) {
            orderType = element[0].getAttribute('data-table-default-order-type');
        }

        var scroll = "";
        if (element[0].id === "table_data_view_properties") {
            scroll = parseInt($(this)[0].getAttribute('data-table-scroll'));
        }

        var paging = true;
        if (element[0].id === "table_data_view_properties" || element[0].id === "table_export_facilities" || element[0].id === "table_export_data_views"
            || element[0].id === "table_database_export_facilities" || element[0].id === "table_database_export_tables") {
            paging = false;
        }

        var columns = [];
        if (element[0].id === "table_users_roles") {
            columns = [
                {
                    targets: [0, 3],
                    visible: false,
                    searchable: false
                }
            ]
        } else if (element[0].id === "table_data_collection_type_master_views" || element[0].id === "table_data_collection_type_course_views_register" || element[0].id === "table_data_collection_type_questionnaires" || element[0].id === "table_data_collection_type_questionnaire_projects") {
            columns = [
                {
                    targets: [0, 2],
                    visible: false,
                    searchable: false
                }
            ]
        } else if (element[0].id === "table_data_view_properties") {
            columns = [
                {
                    targets: 0,
                    searchable: false
                }
            ]
        } else if (element[0].id === "table_export_data_views") {
            columns = [
                {
                    targets: 0,
                    searchable: false
                },
                {
                    targets: [2, 3, 4, 5],
                    visible: false,
                    searchable: false
                }
            ]
        } else if (element[0].id === "table_export_facilities" || element[0].id === "table_database_export_facilities") {
            columns = [
                {
                    targets: [0, 1, 2],
                    searchable: false
                },
                {
                    targets: 3,
                    visible: false,
                    searchable: false
                }
            ]
        } else if (element[0].id === "table_database_export_tables") {
            columns = [
                {
                    targets: 0,
                    searchable: false
                },
                {
                    targets: [2, 3, 4, 5],
                    visible: false,
                    searchable: false
                }
            ]
        } else if (element[0].id === "table_data_views_control_type_values") {
            columns = [
                {
                    targets: 0,
                    visible: false,
                    searchable: false
                },
                {
                    targets: [1, 2, 3, 4],
                    orderable: false
                }
            ]
        } else if (element[0].id === "table_data_views_roles") {
            columns = [
                {
                    targets: 0,
                    visible: false,
                    searchable: false
                },
                {
                    targets: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                    orderable: false
                }
            ]
        } else if (element[0].id === "table_data_views_units") {
            columns = [
                {
                    targets: [0, 5, 6],
                    visible: false,
                    searchable: false
                },
                {
                    targets: [1, 2, 3, 4],
                    orderable: false
                },
                {
                    targets: 3,
                    render: function (data, type, full, meta) {
                        if (type === 'display') {
                            if (utils.isUndefined(data) || data === '') {
                                return full[6];
                            }
                            return utils.numberToString(parseFloat(data));
                        }
                        return data;
                    }
                }
            ]
		} else if (element[0].id === "table_data_views_display_restrictions") {
			columns = [
				{
					targets: [0, 4, 5, 6],
					visible: false,
					searchable: false
				},
				{
					targets: [2, 3],
					render: function (data, type, full, meta) {
						if (type === 'display') {
							return utils.dateToLocaleString(data);
						}
						return data;
					}
				}
			]
        } else if (element[0].id === "table_data_views_integrities") {
            columns = [
                {
                    targets: [0, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70],
                    visible: false,
                    searchable: false
                }
            ]
        } else if (element[0].id === "table_data_views_restrictions") {
            columns = [
                {
                    targets: [0, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71],
                    visible: false,
                    searchable: false
                }
            ]
        } else if (element[0].id === "table_data_collection_type_integrities") {
            columns = [
                {
                    targets: [0, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71],
                    visible: false,
                    searchable: false
                }
            ]
        } else if (element[0].id === "table_data_views_integrities_list") {
            columns = [
                {
                    targets: [0, 3],
                    visible: false,
                    searchable: false
                }
            ]
        } else if (element[0].id === "table_settings_languages") {
            columns = [
                {
                    targets: 0,
                    visible: false,
                    searchable: false
                },
                {
                    targets: 1,
                    sortable: false
                }
            ]
        } else if (/^list_/.test(element[0].id)) {
            jQuery.each(element.find('thead th'), function (i, column) {
                if (i === 0) {
                    columns = [
                        {
                            targets: 0,
                            visible: false,
                            searchable: false
                        }
                    ]
                } else {
                    columns.push(
                        {
                            targets: i,
                            orderable:  false
                        });
                }
            });
        } else if (element[0].id === "table_settings_format_mapping") {
            columns = [
                {
                    targets: [0, 3],
                    visible: false,
                    searchable: false
                }
            ]
        } else if (element[0].id === "table_options_default_unit") {
            columns = [
                {
                    targets: [0, 3, 4],
                    visible: false,
                    searchable: false
                }
            ]
        } else if (element[0].id === "table_options_pattern") {
            columns = [
                {
                    targets: [0, 3, 4],
                    visible: false,
                    searchable: false
                }
            ]
        }else if (element[0].id === "table_merge_conflicts") {
            columns = [
                {
                    targets: [3, 4, 5, 6, 7, 8, 9],
                    visible: false,
                    searchable: false
                }
            ]
        } else if (element[0].id === "table_save_conflicts") {
            columns = [
                {
                    targets: [2, 3],
                    visible: false,
                    searchable: false
                }
            ]
        } else if (element[0].id === "table_news_rights" || element[0].id === "table_documents_rights") {
            columns = [
                {
                    targets: 1,
                    searchable: false,
                    orderable: false
                },
                {
                    targets: [0, 3, 4],
                    visible: false,
                    searchable: false
                }
            ]
        } else if (element[0].id === "table_locked_periods") {
            columns = [
                {
                    targets: [0, 4, 5],
                    visible: false,
                    searchable: false
                },
                {
                    targets: [1],
                    render: function (data, type, full, meta) {
                        if (type === 'display') {
                            return utils.dateToLocaleString(data.split(',')[0]) + ' - ' + utils.dateToLocaleString(data.split(',')[1]);
                        }
                        return data;
                    }
                },
                {
                    targets: [2],
                    render: function (data, type, full, meta) {
                        if (type === 'display') {
                            return utils.dateToLocaleString(data);
                        }
                        return data;
                    }
                }
            ]
        } else if (element[0].id === "table_locked_patients") {
            columns = [
                {
                    targets: [0, 4],
                    visible: false,
                    searchable: false
                },
                {
                    targets: [2],
                    render: function (data, type, full, meta) {
                        if (type === 'display') {
                            return utils.dateToLocaleString(data);
                        }
                        return data;
                    }
                }
            ]
        } else if (element[0].id === "table_agreement_type_documents") {
            columns = [
                {
                    targets: [0, 2],
                    visible: false,
                    searchable: false
                }
            ]
        } else if (element[0].id === "table_aggregation_definition_period_field_conversions") {
            columns = [
                {
                    targets: [0, 5, 6, 7, 8],
                    visible: false,
                    searchable: false
                }
            ]
        } else {
            columns = [
                {
                    targets: 0,
                    visible: false,
                    searchable: false
                }
            ]
        }

        var dataTable = $(this).dataTable({
            processing: false,
            serverSide: false,
            paging: paging,
            info: true,
            autoWidth: false,
            sort: sort,
            scrollY: scroll,
            pageLength: parseInt($(this)[0].getAttribute('data-table-page-length')),
            order: [[parseInt($(this)[0].getAttribute('data-table-default-order-column')), orderType]],
            language: {
                zeroRecords: Lang.get('tripletrax.no_data_found')
            },
            dom: 't',
            columnDefs: columns,
            drawCallback: function (settings) {
                if (paging) {
                    setPaginateButtons($(this), settings, false);
                }

                if (element[0].id === "table_news_rights" || element[0].id === "table_documents_rights") {
                    access.setControlsDependingOnRights($(this).parents('.tt-content-detail'), true, false);
                }
            },
            rowCallback: function (row, data, displayIndex) {

                if ($(this)[0].id === "table_data_views_control_type_values") {
                    data[1] = displayIndex + 1;
                    $('td', row)[0].textContent = displayIndex + 1;
                    row.id = data[0];
                } else if ($(this)[0].id === "table_export_data_views") {
                    $(row).attr('id', data[2] + '|' + data[3]);
                    $(row).attr('data-tt-level', data[4]);
                    $(row).attr('data-tt-name', data[5]);
                    $(row).attr('data-tt-id', 'dv_' + data[2]);
                    $(row).attr('data-tt-parent-id', 'dv_' + data[3]);
                } else if ($(this)[0].id === "table_export_facilities" || $(this)[0].id === "table_database_export_facilities") {
                    $(row).attr('data-tt-id', data[3]);
                } else if ($(this)[0].id === "table_database_export_tables") {
                    $(row).attr('id', data[2] + '|' + data[3]);
                    $(row).attr('data-tt-level', data[4]);
                    $(row).attr('data-tt-table', data[5]);
                    $(row).attr('data-tt-id', 'dv_' + data[2]);
                    $(row).attr('data-tt-parent-id', 'dv_' + data[3]);
                }
            },
            initComplete: function (settings, json) {
                $(this).addClass("datatable-container");
                if ($(this)[0].id === "table_data_views_control_type_values") {
                    $(this).rowReordering();
                } else if ($(this)[0].id === "table_export_data_views" || $(this)[0].id === "table_database_export_tables") {
                    var initial_state = $(this).data().treeInitialState;

                    $(this).treetable({
                        expandable: true,
                        initialState: initial_state
                    });

                    $(this).addClass("tree-container");
                }
            }
        });
    });

	initializeSelect2($(element).find('[name="show_patients_incomplete_course_data_year"]:not(.select2-container)'));
	initializeSelect2($(element).find('.tt-data-collection-type:not(.select2-container)'));

    $(element).find('.tt-datatable-data:not(.datatable-container)').each(function () {

        var element = $(this);

        var sort = true;
        if ($(element[0]).hasClass('tt-not-sortable')) {
            sort = false;
        }

        var orderType = "asc";
        if (!utils.isUndefined(element[0].getAttribute('data-table-default-order-type'))) {
            orderType = element[0].getAttribute('data-table-default-order-type');
        }

        var scroll = "";
        var paging = true;
        if (element[0].id === "table_monitoring_patientlist" || /^table_monitoring_custom_/.test(element[0].id)) {
            paging = false;
        }

        var columns = [
            {
                targets: 0,
                visible: false,
                searchable: false
            }
        ];

        if (element[0].id === 'table_patientlist') {
            var additionalColumns = 0;
            if ($('#locale').data().pseudonymization !== 'none') {
                additionalColumns = 2;
            }
            columns = [
                {
                    data: "id",
                    targets: 0,
                    visible: false,
                    searchable: false
                },
                {
                    data: "pseudonym",
                    targets: 1,
                    render: function (data, type, full, meta) {
                        if (type === 'display') {
                            if (!utils.isUndefined(full['locked_patient']) && full['locked_patient'] === full['id']) {

                                return '<span>' + data + ' </span><i class="fad fa-lock"></i>';
                            }
                            return data;
                        }
                        return data;
                    }
                }
            ];
            if ($('#locale').data().pseudonymization !== 'none') {
                columns.push(
                    {
                        data: "patientname",
                        targets: 2
                    },
                    {
                        data: "prename",
                        targets: 3
                    }
                );
            }
            columns.push(
                {
                    data: "birth_date",
                    targets: 2 + additionalColumns,
                    render: function (data, type, full, meta) {
                        if (type === 'display' || type === 'filter') {
                            if (utils.isUndefined(utils.GLOBALS.idatPatients)) {

                                return utils.dateToLocaleFormatString(data, 'MM/YYYY');
                            }
                            return utils.dateToLocaleString(data);
                        }
                        return utils.dateToString(data);
                    }
                },
                {
                    data: "agreements",
                    targets: 3 + additionalColumns,
                    render: function (data, type, full, meta) {
                        if (data === null) {
                            return '';
                        }
                        return data.replace(/\|0/g, '').replace(/\|2/g, ' (' + trans('tripletrax.agreement_remake') + ')');
                    }
                },
                {
                    data: "state_aggregate",
                    targets: 4 + additionalColumns,
                    render: function (data, type, full, meta) {
                        var returnValue = trans('tripletrax.inactive');
                        if (!utils.isUndefined(data) && data !== '') {
                            jQuery.each(data.split('|'), function (i, val) {
                                var states = val.split(',');
                                if (states[1] === $('#state_values').data().matchValues['patient_active']) {
                                    returnValue = $('#state_values').data().values[states[1]];
                                    return false;
                                } else if (states[0] === '1' && (utils.isUndefined(states[1]) || states[1] === '')) {
                                    returnValue = trans('tripletrax.active');
                                } else if (states[1] !== '' && returnValue === trans('tripletrax.inactive')) {
                                    returnValue = $('#state_values').data().values[states[1]];
                                } else if (states[1] !== '' && returnValue !== trans('tripletrax.active') && returnValue !== $('#state_values').data().values[states[1]]) {
                                    returnValue = trans('tripletrax.patient_inactive');
                                }
                            });
                        }
                        if (full['patient_deceased'] === 1 || full['patient_deceased'] === '1') {
                            returnValue += ', ' + trans('tripletrax.patient_list_deceased');
                        } else if (((full['patient_diagnosis_revoked'] === 1 || full['patient_diagnosis_revoked'] === '1') && (utils.isUndefined(full['patient_diagnosis_confirmed']) || full['patient_diagnosis_confirmed'] === '' || full['patient_diagnosis_confirmed'] === 0 || full['patient_diagnosis_confirmed'] === '0'))
                            || ((full['patient_diagnosis_revoked'] === 1 || full['patient_diagnosis_revoked'] === '1') && (full['patient_diagnosis_confirmed'] === 1 || full['patient_diagnosis_confirmed'] === '1')
                                && (utils.isUndefined(full['patient_diagnosis_revoked_date']) || utils.isUndefined(full['patient_diagnosis_confirmed_date'])
                                    || utils.stringToDate(full['patient_diagnosis_revoked_date']) > utils.stringToDate(full['patient_diagnosis_confirmed_date'])))) {
                            returnValue += ', ' + trans('tripletrax.patient_list_diagnosis_revoked');
                        } else if (((full['patient_released_to_facility'] === 1 || full['patient_released_to_facility'] === '1') && (utils.isUndefined(full['patient_accepted_from_facility']) || full['patient_accepted_from_facility'] === '' || full['patient_accepted_from_facility'] === 0 || full['patient_accepted_from_facility'] === '0'))
                            || ((full['patient_released_to_facility'] === 1 || full['patient_released_to_facility'] === '1') && (full['patient_accepted_from_facility'] === 1 || full['patient_accepted_from_facility'] === '1')
                                && (utils.isUndefined(full['patient_released_to_facility_date']) || utils.isUndefined(full['patient_accepted_from_facility_date'])
                                    || utils.stringToDate(full['patient_released_to_facility_date']) > utils.stringToDate(full['patient_accepted_from_facility_date'])))) {
                            returnValue += ', ' + trans('tripletrax.patient_list_released_to_facility');
                        } else if (((full['patient_released_to_other_facility'] === 1 || full['patient_released_to_other_facility'] === '1') && (utils.isUndefined(full['patient_accepted_from_facility']) || full['patient_accepted_from_facility'] === '' || full['patient_accepted_from_facility'] === 0 || full['patient_accepted_from_facility'] === '0'))
                            || ((full['patient_released_to_other_facility'] === 1 || full['patient_released_to_other_facility'] === '1') && (full['patient_accepted_from_facility'] === 1 || full['patient_accepted_from_facility'] === '1')
                                && (utils.isUndefined(full['patient_released_to_other_facility_date']) || utils.isUndefined(full['patient_accepted_from_facility_date'])
                                    || utils.stringToDate(full['patient_released_to_other_facility_date']) > utils.stringToDate(full['patient_accepted_from_facility_date'])))) {
                            returnValue += ', ' + trans('tripletrax.patient_list_released_to_other_facility');
                        } else if (((full['patient_moved_abroad'] === 1 || full['patient_moved_abroad'] === '1') && (utils.isUndefined(full['patient_accepted_from_facility']) || full['patient_accepted_from_facility'] === '' || full['patient_accepted_from_facility'] === 0 || full['patient_accepted_from_facility'] === '0'))
                            || ((full['patient_moved_abroad'] === 1 || full['patient_moved_abroad'] === '1') && (full['patient_accepted_from_facility'] === 1 || full['patient_accepted_from_facility'] === '1')
                                && (utils.isUndefined(full['patient_moved_abroad_date']) || utils.isUndefined(full['patient_accepted_from_facility_date'])
                                    || utils.stringToDate(full['patient_moved_abroad_date']) > utils.stringToDate(full['patient_accepted_from_facility_date'])))) {
                            returnValue += ', ' + trans('tripletrax.patient_list_moved_abroad');
                        }
                        return returnValue;
                    }
                },
				{
					data: "external_questionnaire_id",
					targets: 5 + additionalColumns,
					visible: false
				},
                {
                    data: "locked_patient",
                    targets: 6 + additionalColumns,
                    visible: false
                },
                {
                    data: "patient_deceased",
                    targets: 7 + additionalColumns,
                    visible: false
                },
                {
                    data: "patient_diagnosis_revoked",
                    targets: 8 + additionalColumns,
                    visible: false
                },
                {
                    data: "patient_diagnosis_revoked_date",
                    targets: 9 + additionalColumns,
                    visible: false
                },
                {
                    data: "patient_diagnosis_confirmed",
                    targets: 10 + additionalColumns,
                    visible: false
                },
                {
                    data: "patient_diagnosis_confirmed_date",
                    targets: 11 + additionalColumns,
                    visible: false
                },
                {
                    data: "patient_released_to_facility",
                    targets: 12 + additionalColumns,
                    visible: false
                },
                {
                    data: "patient_released_to_facility_date",
                    targets: 13 + additionalColumns,
                    visible: false
                },
                {
                    data: "patient_released_to_other_facility",
                    targets: 14 + additionalColumns,
                    visible: false
                },
                {
                    data: "patient_released_to_other_facility_date",
                    targets: 15 + additionalColumns,
                    visible: false
                },
                {
                    data: "patient_accepted_from_facility",
                    targets: 16 + additionalColumns,
                    visible: false
                },
                {
                    data: "patient_accepted_from_facility_date",
                    targets: 17 + additionalColumns,
                    visible: false
                },
                {
                    data: "patient_moved_abroad",
                    targets: 18 + additionalColumns,
                    visible: false
                },
                {
                    data: "patient_moved_abroad_date",
                    targets: 19 + additionalColumns,
                    visible: false
                }
            );
        } else if (element[0].id === 'table_monitoring_patientlist') {
            var additionalColumns = 0;
            if ($('#locale').data().pseudonymization !== 'none') {
                additionalColumns = 5;
            }
            columns = [
                {
                    data: "pseudonym",
                    targets: 0
                }
            ];
            if ($('#locale').data().pseudonymization !== 'none') {
                columns.push(
                    {
                        data: "patientname",
                        targets: 1
                    },
                    {
                        data: "prename",
                        targets: 2
                    },
                    {
                        data: "street",
                        targets: 3
                    },
                    {
                        data: "postal_code",
                        targets: 4
                    },
                    {
                        data: "city",
                        targets: 5
                    }
                );
            }
            columns.push(
                {
                    data: "birth_date",
                    targets: 1 + additionalColumns,
                    render: function (data, type, full, meta) {
                        full['birth_date_display'] = utils.dateToLocaleString(data);
                        if (type === 'display' || type === 'filter') {
                            if (utils.isUndefined(utils.GLOBALS.idatPatients)) {

                                return utils.dateToLocaleFormatString(data, 'MM/YYYY');
                            }
                            return utils.dateToLocaleString(data);
                        }
                        return utils.dateToString(data);
                    }
                },
                {
                    data: "agreements",
                    targets: 2 + additionalColumns,
                    render: function (data, type, full, meta) {
                        var returnValue = '';
                        if (data === null) {

                            returnValue = '';
                        } else {
                            returnValue = data.replace(/\|0/g, '').replace(/\|2/g, ' (' + trans('tripletrax.agreement_remake') + ')');
                        }
                        full['agreements_display'] = returnValue;
                        return returnValue;
                    }
                },
                {
                    data: "state_aggregate",
                    targets: 3 + additionalColumns,
                    render: function (data, type, full, meta) {
                        var returnValue = trans('tripletrax.inactive');
                        if (!utils.isUndefined(data) && data !== '') {
                            jQuery.each(data.split('|'), function (i, val) {
                                var states = val.split(',');
                                if (states[1] === $('#state_values').data().matchValues['patient_active']) {
                                    returnValue = $('#state_values').data().values[states[1]];
                                    return false;
                                } else if (states[0] === '1' && (utils.isUndefined(states[1]) || states[1] === '')) {
                                    returnValue = trans('tripletrax.active');
                                } else if (states[1] !== '' && returnValue === trans('tripletrax.inactive')) {
                                    returnValue = $('#state_values').data().values[states[1]];
                                } else if (states[1] !== '' && returnValue !== trans('tripletrax.active') && returnValue !== $('#state_values').data().values[states[1]]) {
                                    returnValue = trans('tripletrax.patient_inactive');
                                }
                            });
                        }
                        if (full['patient_deceased'] === 1 || full['patient_deceased'] === '1') {
                            returnValue += ', ' + trans('tripletrax.patient_list_deceased');
                        } else if (((full['patient_diagnosis_revoked'] === 1 || full['patient_diagnosis_revoked'] === '1') && (utils.isUndefined(full['patient_diagnosis_confirmed']) || full['patient_diagnosis_confirmed'] === '' || full['patient_diagnosis_confirmed'] === 0 || full['patient_diagnosis_confirmed'] === '0'))
                            || ((full['patient_diagnosis_revoked'] === 1 || full['patient_diagnosis_revoked'] === '1') && (full['patient_diagnosis_confirmed'] === 1 || full['patient_diagnosis_confirmed'] === '1')
                            && (utils.isUndefined(full['patient_diagnosis_revoked_date']) || utils.isUndefined(full['patient_diagnosis_confirmed_date'])
                            || utils.stringToDate(full['patient_diagnosis_revoked_date']) > utils.stringToDate(full['patient_diagnosis_confirmed_date'])))) {
                            returnValue += ', ' + trans('tripletrax.patient_list_diagnosis_revoked');
                        } else if (((full['patient_released_to_facility'] === 1 || full['patient_released_to_facility'] === '1') && (utils.isUndefined(full['patient_accepted_from_facility']) || full['patient_accepted_from_facility'] === '' || full['patient_accepted_from_facility'] === 0 || full['patient_accepted_from_facility'] === '0'))
                            || ((full['patient_released_to_facility'] === 1 || full['patient_released_to_facility'] === '1') && (full['patient_accepted_from_facility'] === 1 || full['patient_accepted_from_facility'] === '1')
                            && (utils.isUndefined(full['patient_released_to_facility_date']) || utils.isUndefined(full['patient_accepted_from_facility_date'])
                            || utils.stringToDate(full['patient_released_to_facility_date']) > utils.stringToDate(full['patient_accepted_from_facility_date'])))) {
                            returnValue += ', ' + trans('tripletrax.patient_list_released_to_facility');
                        } else if (((full['patient_released_to_other_facility'] === 1 || full['patient_released_to_other_facility'] === '1') && (utils.isUndefined(full['patient_accepted_from_facility']) || full['patient_accepted_from_facility'] === '' || full['patient_accepted_from_facility'] === 0 || full['patient_accepted_from_facility'] === '0'))
                            || ((full['patient_released_to_other_facility'] === 1 || full['patient_released_to_other_facility'] === '1') && (full['patient_accepted_from_facility'] === 1 || full['patient_accepted_from_facility'] === '1')
                            && (utils.isUndefined(full['patient_released_to_other_facility_date']) || utils.isUndefined(full['patient_accepted_from_facility_date'])
                            || utils.stringToDate(full['patient_released_to_other_facility_date']) > utils.stringToDate(full['patient_accepted_from_facility_date'])))) {
                            returnValue += ', ' + trans('tripletrax.patient_list_released_to_other_facility');
                        } else if (((full['patient_moved_abroad'] === 1 || full['patient_moved_abroad'] === '1') && (utils.isUndefined(full['patient_accepted_from_facility']) || full['patient_accepted_from_facility'] === '' || full['patient_accepted_from_facility'] === 0 || full['patient_accepted_from_facility'] === '0'))
                            || ((full['patient_moved_abroad'] === 1 || full['patient_moved_abroad'] === '1') && (full['patient_accepted_from_facility'] === 1 || full['patient_accepted_from_facility'] === '1')
                                && (utils.isUndefined(full['patient_moved_abroad_date']) || utils.isUndefined(full['patient_accepted_from_facility_date'])
                                    || utils.stringToDate(full['patient_moved_abroad_date']) > utils.stringToDate(full['patient_accepted_from_facility_date'])))) {
                            returnValue += ', ' + trans('tripletrax.patient_list_moved_abroad');
                        }
                        full['state_aggregate_display'] = returnValue;
                        return returnValue;
                    }
                }
            );
        } else if (/^table_monitoring_custom_/.test(element[0].id)) {
            jQuery.each(element.find('thead th'), function (i, column) {
                if (i === 0) {
                    columns = [
                        {
                            targets: 0,
                            data: "pseudonym",
                            visible: true,
                            searchable: true
                        }
                    ]
                } else {
                    columns.push(
                        {
                            targets: i,
                            data: column.dataset.fieldName,
                            render: function (data, type, full, meta) {
                                var formatColumn = column.dataset.fieldName + '_format';

                                if (column.dataset.controlType === 'date_panel' || column.dataset.controlType === 'date_range') {
                                    if (type === 'display' || type === 'filter') {
                                        if (column.dataset.match === 'birth_date' && utils.isUndefined(utils.GLOBALS.idatPatients)) {

                                            return utils.dateToLocaleFormatString(data, 'MM/YYYY');
                                        } else if (formatColumn in full && !utils.isUndefined(full[formatColumn]) && full[formatColumn] !== '' && full[formatColumn] !== 'full') {

                                            return utils.dateToLocaleFormatString(data, utils.getMomentFormat(full[formatColumn]));
                                        }
                                        return utils.dateToLocaleString(data);
                                    }
                                    return utils.dateToString(data);
                                } else if (column.dataset.dataType === 'integer') {
                                    if (type === 'display' || type === 'filter') {
                                        if (formatColumn in full && !utils.isUndefined(full[formatColumn]) && full[formatColumn] !== '') {
                                            return data + ' ' + full[formatColumn];
                                        }
                                    }
                                    return data;
                                } else if (column.dataset.dataType === 'decimal') {
                                    if (type === 'display' || type === 'filter') {
                                        if (formatColumn in full && !utils.isUndefined(full[formatColumn]) && full[formatColumn] !== '') {
                                            var returnValue = utils.numberToString(parseFloat(data)) + ' ' + full[formatColumn];
                                            var labUnits = $(column).data().labUnits;
                                            jQuery.each(labUnits, function (unit, displayDecimals) {
                                                if (full[formatColumn] === unit) {

                                                    returnValue = utils.numberToString(parseFloat(data), parseInt(displayDecimals)) + ' ' + full[formatColumn];
                                                }
                                            });
                                            return returnValue;
                                        }
                                        if (utils.isUndefined(data) || data === '')
                                        {
                                            return '';
                                        }
                                        return utils.numberToString(parseFloat(data));
                                    }
                                    return data;
                                } else if (Object.keys($(column).data().controlValues).length > 0) {
                                    if (type === 'display' || type === 'filter') {
                                        var returnValue = '';
                                        if (!utils.isUndefined(data)) {
                                            var savedControlValues = data.toString().split('|');
                                            var controlValues = $(column).data().controlValues;
                                            jQuery.each(savedControlValues, function (i, savedControlValue) {
                                                jQuery.each(controlValues, function (controlValueInDatabase, controlValue) {
                                                    if (savedControlValue === controlValueInDatabase) {
                                                        if (returnValue !== '') {
                                                            returnValue += ', ';
                                                        }
                                                        returnValue += controlValue;
                                                    }
                                                });
                                            });
                                        }
                                        return returnValue;
                                    } else {
                                        return data;
                                    }
                                } else {
                                    return data;
                                }
                            }
                        });
                }
            });
        } else if (element[0].id === "table_restore_patient_facilities") {
			columns = [
				{
					targets: 0,
					data: "id",
					visible: false,
					searchable: false
				},
				{
					targets: 1,
					data: "selected",
					render: function (data, type, full, meta) {
						return '<label class="checkbox tt-checkbox-datatable"><input type="checkbox"><i></i></label>';
					}
				},
				{
					targets: 2,
					data: "facilityid"
				},
				{
					targets: 3,
					data: "facilityname"
				}
			];
		} else if (element[0].id === "table_patient_administration_history") {
			columns = [
				{
					targets: 0,
					data: "pseudonym",
					render: function (data, type, full, meta) {
						if (type === 'display') {
							if (!utils.isUndefined(full["merged_pseudonym"]) && full["merged_pseudonym"] !== '') {
								return data + ' ' + trans('tripletrax.merged_with', {'merged_pseudonym': full["merged_pseudonym"]});
							} else {
								return data;
							}
						}
						return data;
					}
				},
				{
					targets: 1,
                    data: "flag",
					render: function (data, type, full, meta) {
						if (type === 'display') {
							if (data === 'MERGE') {
								return trans('tripletrax.merged');
							} else if (data === 'DEL') {
								return trans('tripletrax.deleted');
							} else {
								return data;
							}
						}
						return data;
					}
				},
				{
					targets: 2,
					data: "user"
				},
				{
					targets: 3,
                    data: "created_at",
					render: function (data, type, full, meta) {
						if (type === 'display') {
							return utils.dateToLocaleTimeString(data);
						}
						return data;
					}
				},
				{
					targets: 4,
                    data: "data",
					visible: false
				}
			];
		} else if (element[0].id === "table_audit_trail") {
            columns = [
                {
                    targets: 0,
                    data: "id",
                    visible: false,
                    searchable: false
                },
                {
                    targets: 1,
                    data: "type"
                },
                {
                    targets: 2,
                    data: "pseudonym"
                },
                {
                    targets: 3,
                    data: "examinationdate",
                    render: function (data, type, full, meta) {
                        if (data !== '0000-00-00 00:00:00') {
                            if (type === 'display' || type === 'filter') {
                                return utils.dateToLocaleTimeString(data, false);
                            }
                            return utils.dateToTimeString(data);
                        } else {
                            return '';
                        }
                    }
                },
                {
                    targets: 4,
                    data: "description"
                },
                {
                    targets: 5,
                    data: "database_table"
                },
                {
                    targets: 6,
                    data: "column"
                },
                {
                    targets: 7,
                    data: "old_value"
                },
                {
                    targets: 8,
                    data: "new_value"
                },
                {
                    targets: 9,
                    data: "origin_flag"
                },
                {
                    targets: 10,
                    data: "updated_at",
                    render: function (data, type, full, meta) {
                        if (type === 'display' || type === 'filter') {
                            return utils.dateToLocaleTimeString(data, false);
                        }
                        return utils.dateToTimeString(data);
                    }
                },
                {
                    targets: 11,
                    data: "facility"
                },
                {
                    targets: 12,
                    data: "user"
                }
            ];
        } else if (element[0].id === "table_patient_examination") {
            var facilityId = views.getFacilityId();

            columns = [
                {
                    targets: [0],
                    data: "id",
                    visible: false,
                    searchable: false
                },
                {
                    targets: [1],
                    data: "examinationdate",
                    render: function (data, type, full, meta) {
                        if (type === 'display') {
                            var dateToDisplay = utils.getExaminationDateString(data, full.examinationdate_format);
                            var returnValue = '';

                            if (full.facility_id === facilityId || full.facility_id === facilityId.toString()) {
                                var hasRightCreateExamination = full.data_collection_type_id + '-create_examination-all_rights' in utils.GLOBALS.rights && utils.GLOBALS.rights[full.data_collection_type_id + '-create_examination-all_rights'] == 1;
                                if (hasRightCreateExamination) {
                                    if (utils.isUndefined(full.locked_patient)) {
                                        returnValue = '<span>' + dateToDisplay + '</span><i class="fad fa-pencil-alt tt-edit-examination"></i>';
                                    } else {
                                        returnValue = '<span class="tt-locked-patient-or-period">' + dateToDisplay + '&nbsp;&nbsp;</span><i class="fad fa-lock tt-locked-patient-or-period"></i>';
                                    }
                                } else {
                                    if (utils.isUndefined(full.locked_patient)) {
                                        returnValue = '<span>' + dateToDisplay + '</span>';
                                    } else {
                                        returnValue = '<span class="tt-locked-patient-or-period">' + dateToDisplay + '&nbsp;&nbsp;</span><i class="fad fa-lock tt-locked-patient-or-period"></i>';
                                    }
                                }
                            } else {
                                if (utils.isUndefined(full.locked_patient)) {
                                    returnValue = '<span class="tt-examination-other-facility">' + dateToDisplay + '&nbsp;&nbsp;[' + full.facilitynumber + ']' + '</span>';
                                } else {
                                    returnValue = '<span class="tt-examination-other-facility tt-locked-patient-or-period">' + dateToDisplay + '&nbsp;&nbsp;[' + full.facilitynumber + ']&nbsp;&nbsp;' + '</span><i class="fad fa-lock tt-locked-patient-or-period"></i>';
                                }
                            }
							var questionnaires = views.getQuestionnaires();
							if (Object.keys(questionnaires).length > 0) {
								for (var id in questionnaires) {
									for (var field in full) {
									    var fieldValue = full[field];
									    if (!utils.isUndefined(fieldValue) && fieldValue.toString().indexOf(id + '|') === 0) {
									        if (fieldValue.split('|')[1] === 'existing') {
									            if (utils.isUndefined(full.locked_patient)) {
                                                    returnValue += '<i class="fad fa-question tt-icon-questionnaire" style="color:' + questionnaires[id]['questionnaire_table_color'] + '" rel="tooltip" data-placement="bottom" data-original-title="' + trans('tripletrax.existing_questionnaire_for_project', {project: questionnaires[id]['model']}) + '"></i>';
                                                } else {
                                                    returnValue += '<i class="fad fa-question tt-icon-questionnaire tt-locked-patient-or-period" rel="tooltip" data-placement="bottom" data-original-title="' + trans('tripletrax.existing_questionnaire_for_project', {project: questionnaires[id]['model']}) + '"></i>';
                                                }
												break;
                                            }
                                        }
                                    }
								}
							}
                            return returnValue;
                        }
                        return utils.dateToTimeString(data);
                    }
                }
            ];

            var nextColumnId = 0;
            element.find('thead th').each(function (i) {
                if (!utils.isUndefined($(this).data().columnName)) {
                    columns.push(
                        {
                            targets: i,
                            data: $(this).data().columnName,
                            render: function (data, type, full, meta) {
                                var additionalClass = '';
                                if (full.facility_id !== facilityId && full.facility_id !== facilityId.toString()) {
                                    additionalClass = ' tt-examination-other-facility';
                                }
                                if (!utils.isUndefined(full.locked_patient)) {
                                    additionalClass += ' tt-locked-patient-or-period ';
                                }
                                if (data === '') {
                                    return '<i class="fad fa-minus tt-completeness-examination-tab' + additionalClass + '"></i>';
                                } else if (data === 'existing') {
                                    return '<i class="fad fa-check tt-completeness-examination-tab' + additionalClass + '"></i>';
                                } else if (data == '0') {
                                    return '<i class="fad fa-minus tt-completeness-examination-tab-color-red' + additionalClass + '"></i>';
                                } else if (data == '100') {
                                    return '<i class="fad fa-check tt-completeness-examination-tab-color-green' + additionalClass + '"></i>';
                                } else {
                                    return '<i class="fad fa-check tt-completeness-examination-tab-color-yellow' + additionalClass + '"></i>';
                                }
                            }
                        });
                    nextColumnId = i + 1;
                }
            });

            columns.push(
                {
                    targets: [nextColumnId],
                    data: "locked_patient",
                    visible: false
                });
        } else if (element[0].id === "table_patient_agreement") {
            columns = [
                {
                    targets: [0],
                    data: "id",
                    visible: false,
                    searchable: false
                },
                {
                    targets: 1,
                    data: "description",
					render: function (data, type, full, meta) {
                        if (type === 'display') {
                            if (!utils.isUndefined(full['locked_patient'])) {

                                return '<span>' + data + ' </span><i class="fad fa-lock"></i>';
                            }
                            return data;
                        }
                        return data;
                    }
                },
                {
                    targets: [2],
                    data: "converted_agreement"
                },
                {
                    targets: [3],
                    data: "participantid"
                },
                {
                    targets: [4],
                    data: "begin_date",
                    render: function (data, type, full, meta) {
                        if (type === 'display' || type === 'filter') {
                            return utils.dateToLocaleString(data);
                        }
                        return utils.dateToString(data);
                    }
                },
                {
                    targets: [5],
                    data: "end_date",
                    render: function (data, type, full, meta) {
                        if (type === 'display' || type === 'filter') {
                            return utils.dateToLocaleString(data);
                        }
                        return utils.dateToString(data);
                    }
                },
                {
                    targets: 6,
                    data: "is_active",
                    render: function (data, type, full, meta) {
                        if (!utils.isUndefined(full[7]) && full[7] !== '') {
                            return $('#state_values').data().values[full[7]];
                        } else {
                            return data;
                        }
                    }
                },
                {
                    targets: [7],
                    data: "state",
                    visible: false,
                    searchable: false
                },
                {
                    targets: [8],
                    data: "agreement",
                    visible: false,
                    searchable: false
                },
                {
                    targets: [9],
                    data: "agreement_id",
                    visible: false,
                    searchable: false
                },
                {
                    targets: [10],
                    data: "documents",
                    visible: false,
                    searchable: false
                },
                {
                    targets: [11],
                    data: "data_collection_types",
                    visible: false,
                    searchable: false
                },
                {
                    targets: [12],
                    data: 'patient_agreement_ids',
                    visible: false,
                    searchable: false
                },
                {
                    targets: [13],
                    data: "locked_patient",
                    visible: false,
                    searchable: false
                }
            ];
        } else if (element[0].id === "table_completeness") {
            columns = [
                {
                    targets: [0],
                    data: "id_internal",
                    visible: false,
                    searchable: false
                },
                {
                    targets: [1],
                    data: "facilityid"
                },
                {
                    targets: [2],
                    data: "facilityname"
                },
                {
                    targets: [3],
                    data: "facilitycity"
                },
                {
                    targets: [4],
                    data: "medical_contact"
                },
                {
                    targets: [5],
                    data: "completeness_master",
                    render: function (data, type, full, meta) {

                        if (type === 'display' || type === 'filter') {
                            var value = '';
                            value = value + '<span class="percent percent-sign">' + utils.numberToString(parseFloat(data["current"])) + '</span>';

                            if (!utils.isUndefined(data["change"])) {
                                if (data["change"] === 0) {
                                    value = value + '<span class="tt-bold txt-color-blue"> ( ';
                                } else if (data["change"] > 0) {
                                    value = value + '<span class="tt-bold txt-color-green"> ( + ';
                                } else {
                                    value = value + '<span class="tt-bold txt-color-crimson"> ( ';
                                }
                                value = value + '<span class="percent percent-sign">' + utils.numberToString(parseFloat(data["change"])) + '</span> ) </span>';
                            }
                            return value;
                        }

                        return data;
                    }
                },
                {
                    targets: [6],
                    data: "completeness_course",
                    render: function (data, type, full, meta) {

                        if (type === 'display' || type === 'filter') {
                            var value = '';
                            value = value + '<span class="percent percent-sign">' + utils.numberToString(parseFloat(data["current"])) + '</span>';

                            if (!utils.isUndefined(data["change"])) {
                                if (data["change"] === 0) {
                                    value = value + '<span class="tt-bold txt-color-blue"> ( ';
                                } else if (data["change"] > 0) {
                                    value = value + '<span class="tt-bold txt-color-green"> ( + ';
                                } else {
                                    value = value + '<span class="tt-bold txt-color-crimson"> ( ';
                                }
                                value = value + '<span class="percent percent-sign">' + utils.numberToString(parseFloat(data["change"])) + '</span> ) </span>';
                            }
                            return value;
                        }
                        return data;
                    }
                },
                {
                    targets: [7],
                    data: "completeness_last_email_date",
                    render: function (data, type, full, meta) {

                        if (type === 'display' || type === 'filter') {
                            var dateToDisplay = utils.dateToLocaleString(data);
                            return data === null? '-' :  '<span>' + dateToDisplay + '</span>';
                        }
                        return data;
                    }
                },
                {
                    targets: [8],
                    data: "count_patients",
					render: function (data, type, full, meta) {

						if (type === 'display' || type === 'filter') {
							var value = '';
							var diff = 0;
							value = value + '<span>' + utils.numberToString(data["current"]) + '</span>';

                            if (!utils.isUndefined(data["change"])){
                                value = value + '<span> /' +  utils.numberToString(data["change"]) + '</span>';
                                diff = data["current"] - data["change"];
                                if (diff === 0){
                                    value = value + '<span class="tt-bold txt-color-blue"> ( ';
                                } else if (diff > 0) {
                                    value = value + '<span class="tt-bold txt-color-green"> ( + ';
                                } else {
									value = value + '<span class="tt-bold txt-color-crimson"> ( ';
								}
                                value = value + '<span class=>' + utils.numberToString(diff) + '</span> ) </span>';
                            }
							return value;
						}
						return data;
					}
                },
                {
                    targets: [9],
                    data: "count_patients_agreement",
					render: function (data, type, full, meta) {

						if (type === 'display' || type === 'filter') {
							var value = '';
							var diff = 0;
							value = value + '<span>' + utils.numberToString(data["current"]) + '</span>';

							if (!utils.isUndefined(data["change"])){
								value = value + '<span> /' +  utils.numberToString(data["change"]) + '</span>';
								diff = data["current"] - data["change"];
								if (diff === 0){
									value = value + '<span class="tt-bold txt-color-blue"> ( ';
								} else if (diff > 0) {
									value = value + '<span class="tt-bold txt-color-green"> ( + ';
								} else {
									value = value + '<span class="tt-bold txt-color-crimson"> ( ';
								}
								value = value + '<span class=>' + utils.numberToString(diff) + '</span> ) </span>';
							}
							return value;
						}
						return data;
					}
                },
                {
                    targets: [10],
                    data: "count_patients_agreement_renewal",
					render: function (data, type, full, meta) {

						if (type === 'display' || type === 'filter') {
							var value = '';
							var diff = 0;
							value = value + '<span>' + utils.numberToString(data["current"]) + '</span>';

							if (!utils.isUndefined(data["change"])){
								value = value + '<span> /' +  utils.numberToString(data["change"]) + '</span>';
								diff = data["current"] - data["change"];
								if (diff === 0){
									value = value + '<span class="tt-bold txt-color-blue"> ( ';
								} else if (diff > 0) {
									value = value + '<span class="tt-bold txt-color-green"> ( + ';
								} else {
									value = value + '<span class="tt-bold txt-color-crimson"> ( ';
								}

								value = value + '<span class=>' + utils.numberToString(diff) + '</span> ) </span>';
							}
							return value;
						}
						return data;
					}
                },
                {
                    data: "medical_contact_email",
                    visible: false,
                    searchable: false
                },
				{
					data: "completeness_completed",
					visible: false,
					searchable: false
				}
            ];
        } else if (element[0].id === "table_aggregation_preview"){

            columns = [
                {
					data: "field_target_model",
                    searchable: false
				},
                {
                    data: "value_after_aggregation",
					searchable: false
				},
				{
					data: "field_source_model",
					searchable: false
				},
				{
					data: "value_before_aggregation",
					searchable: false
				},
				{
					data: "category",
					visible: false
				}
            ];
            // 'id', 'source_desc', 'target_desc', 'converted_aggregation', 'aggregation_rules', 'valid_from', 'valid_till', 'position', 'order', 'name'
		} else if (element[0].id === "table_aggregation_definition") {
			columns = [
				{
					targets: [0],
					data: "id",
					searchable: false,
					visible: false
				},
				{
				    targets: [1],
					data: "tab",
					visible: false
				},
				{
					targets: [2],
					data: "source_desc"
				},
				{
					targets: [3],
					data: "target_desc"
				},
				{
					targets: [4],
					data: "converted_aggregation"
				},
				{
					targets: [5],
					data: "aggregation_rules"
				},
				{
					targets: [6],
					data: "valid_from",
					render: function (data, type, full, meta) {
						if (type === 'display') {
							return utils.dateToLocaleString(data);
						}
						return data;
					}
				},
				{
					targets: [7],
					data: "valid_till",
					render: function (data, type, full, meta) {
						if (type === 'display') {
							return utils.dateToLocaleString(data);
						}
						return data;
					}
				},
				{
					data: "position",
					searchable: false,
					visible: false
				},
				{
					data: "order",
					searchable: false,
					visible: false
				},
				{
					data: "name",
					searchable: false,
					visible: false
				},
				{
					data: "tab_name",
					visible: false
				}
			];
        }

        if (element[0].id === "table_patientlist" || element[0].id === "table_monitoring_patientlist") {
            initializeDataTableWithData(element, paging, sort, scroll, orderType, columns, null);

            if ($('[name="show_patients_active"]').length && !utils.isUndefined(utils.GLOBALS.showAllActivePatients)) {
                $('[name="show_patients_active"]').prop('checked', utils.GLOBALS.showAllActivePatients);
                utils.updateGlobals('showAllActivePatients', null);
            }
            if ($('[name="show_patients_incomplete_master_data"]').length && !utils.isUndefined(utils.GLOBALS.showAllIncompleteMasterPatients)) {
                $('[name="show_patients_incomplete_master_data"]').prop('checked', utils.GLOBALS.showAllIncompleteMasterPatients);
                utils.updateGlobals('showAllIncompleteMasterPatients', null);
            }
            if ($('[name="show_patients_incomplete_course_data"]').length && !utils.isUndefined(utils.GLOBALS.showAllIncompleteCoursePatients)) {
                $('[name="show_patients_incomplete_course_data"]').prop('checked', utils.GLOBALS.showAllIncompleteCoursePatients);
				$('[name="show_patients_incomplete_course_data_year"]').removeAttr('disabled');
                $('[name="show_patients_incomplete_course_data_year"]').val(utils.GLOBALS.showAllIncompleteCourseYearPatients).trigger('change.select2');
                if (utils.GLOBALS.showAllIncompleteCourseYearPatients) {
					$('.tt-limit-examination-list').removeClass('hide');
					$('[name="limit_examination_list_completeness_selections"]').attr('checked', 'checked');
				} else {
					$('.tt-limit-examination-list').addClass('hide');
					$('[name="limit_examination_list_completeness_selections"]').removeAttr('checked');
                }
                utils.updateGlobals('showAllIncompleteCoursePatients', null);
                utils.updateGlobals('showAllIncompleteCourseYearPatients', null);
            }

            patients.loadPatientlist(true).done(function (patientData) {

                var data = patients.getPatientlist(patientData);
                $(element).DataTable().rows.add(data).draw();

                // Wenn ein Patient direkt ausgewählt werden soll, aktuellen Patient in der Liste auswählen
                if (!utils.isUndefined(utils.GLOBALS.patientToShow) && utils.GLOBALS.patientToShow !== '') {

                    $('#table_patientlist').DataTable().page.jumpToData(utils.GLOBALS.patientToShow, 0);
                    $('#table_patientlist').find('tr[id="' + utils.GLOBALS.patientToShow + '"]').addClass('selected-row');
                    $('#table_patientlist').find('tr[id="' + utils.GLOBALS.patientToShow + '"]').find('td')[0].click();

                    // Wenn keine Untersuchung direkt ausgewählt werden soll, auf den ersten Tab der Stammdaten springen
                    if (utils.isUndefined(utils.GLOBALS.examinationToShow) || utils.GLOBALS.examinationToShow === '') {
                        $('#table_patientlist').find('tr[id="' + utils.GLOBALS.patientToShow + '"]').find('td')[0].click();
                    }

                    utils.updateGlobals('patientToShow', null);
                }

                if ($('.tt-datatable-patient-search').length && !utils.isUndefined(utils.GLOBALS.searchString) && utils.GLOBALS.searchString.length) {
                    $('.tt-datatable-patient-search').val(utils.GLOBALS.searchString);
                    var e = jQuery.Event("keyup");
                    e.keyCode = 13;
                    $('.tt-datatable-patient-search').trigger(e);
                    utils.updateGlobals('searchString', '');
                }

                if ($('.tt-export-monitoring-result').length) {
                    $('.tt-export-monitoring-result').removeAttr('disabled');
                }
            });
        } else if (/^table_monitoring_custom_/.test(element[0].id)) {
            initializeDataTableWithData(element, paging, sort, scroll, orderType, columns, null);

            monitoring.loadCustomMonitoringPatientlist(element[0].id.substring(element[0].id.lastIndexOf('_') + 1)).done(function (patientData) {

                var data = patients.getPatientlist(patientData);
                $(element).DataTable().rows.add(data).draw();
                $('.tt-export-monitoring-result').removeAttr('disabled');
            });

        } else {
            initializeDataTableWithData(element, paging, sort, scroll, orderType, columns, null);
        }

    });

    $(element).find('.tt-colorpicker:not(.colorpicker-container)').each(function() {

        $(this).colorpicker();

        $(this).addClass("colorpicker-container");
    });

	// muss nach der Initialisierung der Datatables kommen
	initializeSelect2($(element).find('.tt-select2:not(.select2-container)'));

    if ($.fn.easyPieChart) {

        $(element).find('.easy-pie-chart:not(.easy-pie-chart-container)').each(function() {
            var $this = $(this),
                barColor = $this.css('color') || $this.data('pie-color'),
                trackColor = $this.data('pie-track-color') || 'rgba(0,0,0,0.04)',
                size = parseInt($this.data('pie-size')) || 25;

            $this.easyPieChart({

                barColor : barColor,
                trackColor : trackColor,
                scaleColor : false,
                lineCap : 'butt',
                lineWidth : parseInt(size / 8.5),
                animate : 1500,
                rotate : -90,
                size : size,
                onStep: function(from, to, percent) {
                    $(this.el).find('.percent').text(Math.round(percent));
                }

            });

            $this.addClass("easy-pie-chart-container");
            $this = null;
        });

    }

    // console.log(element);
	// console.time('setControlsDependingOnRights: initialize');
    access.setControlsDependingOnRights(element, isOwnFacility, isLocked);
	// console.timeEnd('setControlsDependingOnRights: initialize');
}

function setPaginateButtons(oTable, oSettings, setPageButtons) {
    if (oSettings !== null) {
        if (oSettings._iDisplayStart + oSettings._iDisplayLength >= oSettings.fnRecordsDisplay() || oSettings.fnRecordsTotal() <= oSettings._iDisplayLength) {
            oTable.parents('.tt-content-datatable').find('.tt-datatable-next').addClass('disabled');
        } else {
            oTable.parents('.tt-content-datatable').find('.tt-datatable-next').removeClass('disabled');
        }
        if (setPageButtons) {
            $('#' + oTable.attr('id') + '_paginate').addClass('hide');
            $(oTable.parents('.tt-content-datatable').find('.tt-datatable-next')[0]).parent().find('.tt-button-paginate').remove();
            if ($('#' + oTable.attr('id') + '_paginate').find('li').length > 3) {
                jQuery.each($('#' + oTable.attr('id') + '_paginate').find('li'), function (i, button) {
                    if ($(button).hasClass('previous') || $(button).hasClass('next')) {
                        return;
                    }
                    var additionalClass = '';
                    if ($(button).hasClass('disabled')) {
                        additionalClass = ' disabled';
                    }
                    if ($(button).hasClass('active')) {
                        additionalClass += ' active';
                    }
                    oTable.parents('.tt-content-datatable').find('.tt-datatable-next').before(
                        '<button class="btn btn-default tt-button-paginate' + additionalClass + '" data-page="' + $(button).text() + '">' +
                        $(button).text() +
                        '</button>'
                    );
                });
            }
        }
        if (oSettings._iDisplayStart == 0) {
            oTable.parents('.tt-content-datatable').find('.tt-datatable-previous').addClass('disabled');
        } else {
            oTable.parents('.tt-content-datatable').find('.tt-datatable-previous').removeClass('disabled');
        }
    }
}

function initializeDataTableWithData(table, paging, sort, scroll, orderType, columns, data) {

    table.dataTable({
        processing: false,
        serverSide: false,
        paging: paging,
        info: true,
        autoWidth: false,
        sort: sort,
        scrollY: scroll,
        data: data,
        pageLength: parseInt(table[0].getAttribute('data-table-page-length')),
        order: [[parseInt(table[0].getAttribute('data-table-default-order-column')), orderType]],
        language: {
            zeroRecords: Lang.get('tripletrax.no_data_found')
        },
        dom: 'tp',
        columns: columns,
        drawCallback: function (settings) {
            if (paging) {
                setPaginateButtons($(this), settings, true);
            }
			if ($(this).parents('.tt-content-datatable').find('.tt-count-patients').length) {
				var countPatientsElement = $(this).parents('.tt-content-datatable').find('.tt-count-patients');
				if (settings.fnRecordsTotal() !== settings.fnRecordsDisplay()) {
					countPatientsElement.text(countPatientsElement.text().substring(0, countPatientsElement.text().indexOf(':') + 1) + ' ' + settings.fnRecordsTotal() + ' - ' + trans('tripletrax.filtered') + ': ' + settings.fnRecordsDisplay());
				} else {
					countPatientsElement.text(countPatientsElement.text().substring(0, countPatientsElement.text().indexOf(':') + 1) + ' ' + settings.fnRecordsTotal());
				}
			}
			if (!utils.isUndefined(table[0].getAttribute('data-group-column'))) {
				var api = this.api();
				var rows = api.rows({page:'current'}).nodes();
				var last = null;
				var groupColumn = parseInt(table[0].getAttribute('data-group-column'));

				api.column(groupColumn, {page:'current'}).data().each(function(group, i) {
					if (last !== group) {
						$(rows).eq(i).before(
							'<tr class="group tt-datatable-group"><td colspan="6">' + group + '</td></tr>'
						);
						last = group;
					}
				});
			}
			$('.tt-icon-questionnaire').tooltip();
        },
        rowCallback: function (row, data, displayIndex) {
            row.id = data.id;
            if (table[0].id === 'table_audit_trail') {
                if (data['type'] === 'CREATED') {
                    $(row).addClass('tt-created');
                } else if (data['type'] === 'DELETED') {
                    $(row).addClass('tt-deleted');
                }
            } else if (table[0].id === "table_patientlist" || table[0].id === "table_patient_agreement") {
                if (!utils.isUndefined(data['locked_patient'])) {
                    $('td', row).addClass('tt-locked-patient-or-period');
                }
            }
        },
        initComplete: function (settings, json) {
            $(this).addClass("datatable-container");
        }
    });
}

function initializeSelect2(elements) {

    elements.each(function () {

        if ($(this).hasClass('tt-integrity-field')) {

            integrities.setIntegrityComboboxItems($(this).parents('form'), '', true);

        } else if ($(this).hasClass('tt-monitoring-restriction-custom-field')) {

            var data = $(this).data();
            var name = $(this)[0].name;
            var form = $(this).parents('form')[0];

            var fieldTableType = '';
            if (data.tableType === 'master_table' || data.tableType === 'master_facility_table') {
                fieldTableType = 'master';
            } else if (data.tableType === 'course_table' || data.tableType === 'course_facility_table') {
                fieldTableType = 'course';
            } else if (data.tableType === 'period_table' || data.tableType === 'period_facility_table') {
                fieldTableType = 'period_' + data.table;
            }

            if (data.controlType == 'date_panel' || data.controlType == 'date_range') {
                fieldTableType = 'date_fields_' + fieldTableType;
            } else if (data.dataType == 'decimal' || data.dataType == 'integer') {
                fieldTableType = 'number_fields_' + fieldTableType;
            }

            monitoring.setMonitoringRestrictionFieldSelection(name, fieldTableType, $(this).attr('class'), form);

            if (data.initValue !== '') {
                $(form).find('[name="' + name + '"]').val(data.initValue).trigger('change.select2');
            }
            if (!utils.isUndefined(data.dataView) && data.dataView !== '') {
                $(form).find('[name="' + name + '"]').data('dataView', data.dataView);
            }

        } else if ($(this).hasClass('tt-monitoring-restriction-field')) {

            monitoring.setMonitoringRestrictionComboboxItems($(this).parents('form'), '', true);

        } else if ($(this).hasClass('tt-multiple-select-own-entry')) {

            var options = $(this).data('optionValues');
            var data = [];
            var attributes = '';
            var parent = $(this).parent();
            var selection = $(this).data('selectionValues');
            var ownSelection = $.map(selection, function(el) {
                return $.inArray(el, options) < 0 ? el : null;
            });

            jQuery.each(options, function (i, val) {
                if(Object.prototype.toString.call(options) === '[object Array]') {
                    data.push({id: val, text: val});
                } else {
                    data.push({id: i, text: val});
                }
            });
            jQuery.each(ownSelection, function (i, val) {
                if(Object.prototype.toString.call(ownSelection) === '[object Array]') {
                    data.push({id: val, text: val});
                } else {
                    data.push({id: i, text: val});
                }
            });

            if (!utils.isUndefined($(this).attr('data-select2-placeholder'))) {
                attributes = 'data-select2-placeholder="' + $(this).attr('data-select2-placeholder') + '"';
            }

            if (!utils.isUndefined($(this).attr('data-action'))) {
                attributes += ' data-action="' + $(this).attr('data-action') + '"';
            }

            validator.reinitializeSelect2(parent, $(this)[0].className + ' select2-container', attributes, data, true);

            if (!utils.isUndefined(selection) && selection !== '') {
                parent.find('.tt-select2').val(selection).trigger('change.select2');
            }

        } else if ($(this).hasClass('tt-select-ajax')) {

            var placeHolderString = Lang.get('tripletrax.no_selection');
            var attributePlaceholder = $(this).attr('data-select2-placeholder');
            var multiple = false;
            var attributeMultiple = $(this).attr('data-select2-multiple');
            var url = $(this).attr('data-select2-url');

            if (!utils.isUndefined(attributePlaceholder) && attributePlaceholder !== '') {
                placeHolderString = Lang.get('tripletrax.' + attributePlaceholder);
            }
            if (!utils.isUndefined(attributeMultiple) && attributeMultiple !== '') {
                multiple = attributeMultiple;
            }

            $(this).select2({
                placeholder: placeHolderString,
                allowClear: true,
                multiple: multiple,
                minimumInputLength: 2,
                ajax: {
                    url: url,
                    dataType: 'json',
                    quietMillis: 250,
                    data: function (term, page) { // page is the one-based page number tracked by Select2
                        return {
                            term: term, //search term
                            page: page // page number
                        };
                    },
					processResults: function (data, page) {

                        if (this.url === "admin/patient_administration_history/patients") {
							var result = [];
							$.each(data, function (i, val) {
								result.push({id: val["pseudonym"], text: val["pseudonym"]});
							});
							return { results: result };
                        } else {
							return { results: data };
                        }
                    }
                },
				language: {
					inputTooShort: function () {
						return Lang.get('tripletrax.input_too_short_string', {'minLength': 2});
					},
					searching: function () {
						return Lang.get('tripletrax.searching');
					},
					noMatches: function (term) {
						if (term === '') {
							return Lang.get('tripletrax.no_more_data_existing');
						} else {
							return Lang.get('tripletrax.no_data_found');
						}
					}
				},
				templateResult: validator.format,
				templateSelection: validator.format
            });

        } else {
            var placeHolderString = Lang.get('tripletrax.no_selection');
            var attributePlaceholder = $(this).attr('data-select2-placeholder');
			var attributeEmptyPlaceholder = $(this).attr('data-select2-empty-placeholder');
            var attributeData = $(this).attr('data-select2-data');
            var data = null;
            var attributeMultiple = $(this).attr('data-select2-multiple');
            var multiple = false;
			var attributeAllowClear = $(this).attr('data-select2-allow-clear');
            var allowClear = true;
			var attributeTags = $(this).attr('data-select2-tags');
            var tags = false;

            if (!utils.isUndefined(attributePlaceholder) && attributePlaceholder !== '') {
                placeHolderString = Lang.get('tripletrax.' + attributePlaceholder);
            } else if (!utils.isUndefined(attributeEmptyPlaceholder) && attributeEmptyPlaceholder) {
				placeHolderString = '';
            }
            if (!utils.isUndefined(attributeData) && attributeData !== '') {
                data = jQuery.parseJSON(attributeData);
            }
            if (!utils.isUndefined(attributeMultiple) && attributeMultiple !== '') {
                multiple = attributeMultiple;
            }
			if (!utils.isUndefined(attributeAllowClear) && attributeAllowClear !== '') {
				allowClear = attributeAllowClear;
			}
			if (!utils.isUndefined(attributeTags) && attributeTags !== '') {
				tags = attributeTags;
			}

            if (data == null) {
                $(this).select2({
                    allowClear: allowClear,
					tags: tags,
					placeholder: placeHolderString,
                    formatNoMatches: function (term) {
                        if (term === '') {
                            return Lang.get('tripletrax.no_more_data_existing');
                        } else {
                            return Lang.get('tripletrax.no_data_found');
                        }
                    },
					templateResult: validator.format,
					templateSelection: validator.format
                });
            } else {
                $(this).select2({
					allowClear: allowClear,
					tags: tags,
                    placeholder: placeHolderString,
                    multiple: multiple,
                    data: data,
                    formatNoMatches: function (term) {
                        if (term === '') {
                            return Lang.get('tripletrax.no_more_data_existing');
                        } else {
                            return Lang.get('tripletrax.no_data_found');
                        }
                    },
					templateResult: validator.format,
					templateSelection: validator.format
                });
            }
        }

        $(this).addClass("select2-container");
    });
}

function initializeSummernote(elements) {

    elements.each(function () {

        $(this).summernote({
			dialogsInBody: true,
            height: '200',
            lang: $('#locale').data().locale,
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontsize', ['fontsize']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
				['insert', ['link', 'picture']]
            ],
			callbacks: {
				onChange: function (contents, $editable) {
					if ($(this).parents('.tt-content-detail').find('.tt-summernote-changes').val() !== 'changed') {
						$(this).parents('.tt-content-detail').find('.tt-summernote-changes').val("changed");
						$("#content-detail").find('form').trigger('checkform.areYouSure');
					}
				},
				onInit: function () {

					if ($(this).hasClass('tt-settings-mail-message')) {
						// Für die Standardnachricht der E-Mail 4 Buttons für "Variablen hinzufügen"
						var contact_button = '<button id="settings_mail_message_add_contact" type="button" class="btn btn-default btn-sm btn-small" title="' + Lang.get('tripletrax.settings_mail_message_add_contact_variable') + '" data-event="something" tabindex="-1">' + Lang.get('tripletrax.settings_mail_message_contact_variable') + '</button>';
						var master_data_button = '<button id="settings_mail_message_add_completeness_master_data" type="button" class="btn btn-default btn-sm btn-small" title="' + Lang.get('tripletrax.settings_mail_message_add_completeness_master_data_variable') + '" data-event="something" tabindex="-1">' + Lang.get('tripletrax.settings_mail_message_completeness_master_data_variable') + '</button>';
						var course_data_button = '<button id="settings_mail_message_add_completeness_course_data" type="button" class="btn btn-default btn-sm btn-small" title="' + Lang.get('tripletrax.settings_mail_message_add_completeness_course_data_variable') + '" data-event="something" tabindex="-1">' + Lang.get('tripletrax.settings_mail_message_completeness_course_data_variable') + '</button>';
						var count_patients_button = '<button id="settings_mail_message_add_count_patients" type="button" class="btn btn-default btn-sm btn-small" title="' + Lang.get('tripletrax.settings_mail_message_add_count_patients_variable') + '" data-event="something" tabindex="-1">' + Lang.get('tripletrax.settings_mail_message_count_patients_variable') + '</button>';
						var fileGroup = '<div class="note-file btn-group">' + contact_button + master_data_button + course_data_button + count_patients_button + '</div>';
						$(fileGroup).appendTo($('.note-toolbar'));
						// Button tooltips
						$('#settings_mail_message_add_contact').tooltip({container: 'body', placement: 'bottom'});
						$('#settings_mail_message_add_completeness_master_data').tooltip({container: 'body', placement: 'bottom'});
						$('#settings_mail_message_add_completeness_course_data').tooltip({container: 'body', placement: 'bottom'});
						$('#settings_mail_message_add_count_patients').tooltip({container: 'body', placement: 'bottom'});
						// Button events
						$('#settings_mail_message_add_contact').click(function (event) {
							$('#settings_mail_message').summernote('editor.saveRange');
							$('#settings_mail_message').summernote('editor.restoreRange');
							$('#settings_mail_message').summernote('editor.focus');
							$('#settings_mail_message').summernote('editor.insertText', '[$ansprechpartner$]');
						});
						$('#settings_mail_message_add_completeness_master_data').click(function (event) {
							$('#settings_mail_message').summernote('editor.saveRange');
							$('#settings_mail_message').summernote('editor.restoreRange');
							$('#settings_mail_message').summernote('editor.focus');
							$('#settings_mail_message').summernote('editor.insertText', '[$vollstaendigkeit_stammdaten$]');
						});
						$('#settings_mail_message_add_completeness_course_data').click(function (event) {
							$('#settings_mail_message').summernote('editor.saveRange');
							$('#settings_mail_message').summernote('editor.restoreRange');
							$('#settings_mail_message').summernote('editor.focus');
							$('#settings_mail_message').summernote('editor.insertText', '[$vollstaendigkeit_verlaufsdaten$]');
						});
						$('#settings_mail_message_add_count_patients').click(function (event) {
							$('#settings_mail_message').summernote('editor.saveRange');
							$('#settings_mail_message').summernote('editor.restoreRange');
							$('#settings_mail_message').summernote('editor.focus');
							$('#settings_mail_message').summernote('editor.insertText', '[$anzahl_patienten$]');
						});
					}
				}
			}
        });

        // Wert setzen
        var initValue = $(this).data().initValue;
        if (!utils.isUndefined(initValue) && initValue !== '') {
            $(this).summernote('code', initValue);
        }

        // Rechte setzen
        var rightClass = '';
        if ($(this).hasClass('tt-right-summernote-write')) {
            rightClass = 'write';
        } else if ($(this).hasClass('tt-right-summernote-update')) {
            rightClass = 'update';
        }

        $.each($(this).parents('.tt-news-message-fieldset').find('button'), function (i, button) {
            $(button).addClass('tt-right-button-' + rightClass);
        });

        $(this).parents('.tt-news-message-fieldset').find('.note-editable').addClass('tt-right-note-editable-' + rightClass);

        access.setControlsDependingOnRights($(this), true, false);

		// Link Dialog definieren
		var linkDialog = $('.link-dialog');
		linkDialog.addClass('fade');
		linkDialog.find('.modal-dialog').addClass('tripletrax-modal-dialog-35').addClass('summernote-modal');
		linkDialog.find('.modal-header').addClass('tripletrax-modal-header').addClass('summernote-modal-header');
		linkDialog.find('.modal-header').find('button').remove();
		linkDialog.find('.modal-title').addClass('tripletrax-modal-title');
		linkDialog.find('.modal-body').addClass('summernote-modal-body');
		linkDialog.find('.checkbox').addClass('hide');
		linkDialog.find('.modal-footer').addClass('tripletrax-modal-footer');
		linkDialog.find('.modal-footer').find('button').text('');
		linkDialog.find('.modal-footer').find('button').removeClass('btn-primary').addClass('btn-success');
		linkDialog.find('.modal-footer').find('button').append('<i class="fad fa-check"></i>');
		linkDialog.find('.modal-footer').find('button').attr('rel', 'tooltip');
		linkDialog.find('.modal-footer').find('button').attr('data-placement', 'bottom');
		linkDialog.find('.modal-footer').find('button').attr('data-original-title', Lang.get('tripletrax.add_link'));
		linkDialog.find('input').addClass('summernote-modal-input');
		linkDialog.find('label').addClass('summernote-modal-label');
		linkDialog.find('.modal-footer').find('button').remove();
		var buttonText =
			'<fieldset class="background-color-transparent no-padding">' +
			'<div class="pull-right">' +
			'<div class="btn-toolbar pull-right">' +
			'<div class="btn-group">' +
			'<button class="btn btn-danger tt-dialog-cancel" data-dismiss="modal" area-hidden="true" rel="tooltip" data-placement="bottom" data-original-title="' + Lang.get('tripletrax.cancel') + '">' +
			'<i class="fad fa-times"></i>' +
			'</button>' +
			'</div>' +
			'<div class="btn-group">' +
			'<button href="#" class="btn note-link-btn btn-success" rel="tooltip" data-placement="bottom" data-original-title="' + Lang.get('tripletrax.add_link') + '">' +
			'<i class="fad fa-check"></i>' +
			'</button>' +
			'</div>' +
			'</div>' +
			'</div>' +
			'</fieldset>';
		linkDialog.find('.modal-footer').append(buttonText);

		// Bilder Dialog definieren
		var imageDialog = $('.note-image-input').parents('.modal');
		imageDialog.addClass('fade');
		imageDialog.find('.modal-dialog').addClass('tripletrax-modal-dialog-35').addClass('summernote-modal');
		imageDialog.find('.modal-header').addClass('tripletrax-modal-header').addClass('summernote-modal-header');
		imageDialog.find('.modal-header').find('button').remove();
		imageDialog.find('.modal-title').addClass('tripletrax-modal-title');
		imageDialog.find('.modal-body').addClass('summernote-modal-body');
		$(imageDialog.find('.summernote-modal-body').children()[1]).remove();
		imageDialog.find('.modal-footer').addClass('tripletrax-modal-footer');
		imageDialog.find('.modal-footer').find('button').text('');
		imageDialog.find('.modal-footer').find('button').removeClass('btn-primary').removeClass('note-image-btn').addClass('btn-danger').addClass('tt-dialog-cancel');
		imageDialog.find('.modal-footer').find('button').removeClass('disabled').removeAttr('disabled');
		imageDialog.find('.modal-footer').find('button').removeAttr('href');
		imageDialog.find('.modal-footer').find('button').append('<i class="fad fa-times"></i>');
		imageDialog.find('.modal-footer').find('button').attr('rel', 'tooltip');
		imageDialog.find('.modal-footer').find('button').attr('data-placement', 'bottom');
		imageDialog.find('.modal-footer').find('button').attr('data-original-title', Lang.get('tripletrax.cancel'));
		imageDialog.find('.modal-footer').find('button').attr('data-dismiss', 'modal');
		imageDialog.find('.modal-footer').find('button').attr('area-hidden', 'true');
		imageDialog.find('input').addClass('summernote-modal-input');
		imageDialog.find('label').addClass('summernote-modal-label');
		imageDialog.find('.note-image-input').addClass('hide');
		buttonText =
			'<button class="btn btn-warning margin-left-15 tt-select-news-image" rel="tooltip" data-placement="bottom" data-original-title="' + Lang.get('tripletrax.select_file') + '">' +
			'<i class="fad fa-folderpen"></i>' +
			'</button>';
		imageDialog.find('.note-group-select-from-files').append(buttonText);

        $(this).addClass("summernote-container");
    });
}

function initializeDatepicker(elements) {

    elements.each(function () {

        var dataDateFormat = $(this).data('dateformat') || 'full';

        if (dataDateFormat === 'full') {
            dataDateFormat = utils.getLocaleDateFormat();
        }
        dataDateFormat = utils.getMomentFormat(dataDateFormat);
        $(this).mask('?' + utils.getLocaleDateFormatMask(dataDateFormat), { placeholder: '_' });

        $(this).data('format', dataDateFormat);
        var picker = new Pikaday({
            field: $(this)[0],
            format: dataDateFormat,
            firstDay: 1,
            yearRange: 20,
            i18n: {
                previousMonth : trans('tripletrax.previous_month'),
                nextMonth     : trans('tripletrax.next_month'),
                months        : [trans('tripletrax.january'),trans('tripletrax.february'),trans('tripletrax.march'),trans('tripletrax.april'),trans('tripletrax.may'),trans('tripletrax.june'),trans('tripletrax.july'),trans('tripletrax.august'),trans('tripletrax.september'),trans('tripletrax.october'),trans('tripletrax.november'),trans('tripletrax.december')],
                weekdays      : [trans('tripletrax.sunday'),trans('tripletrax.monday'),trans('tripletrax.tuesday'),trans('tripletrax.wednesday'),trans('tripletrax.thursday'),trans('tripletrax.friday'),trans('tripletrax.saturday')],
                weekdaysShort : [trans('tripletrax.sunday_short'),trans('tripletrax.monday_short'),trans('tripletrax.tuesday_short'),trans('tripletrax.wednesday_short'),trans('tripletrax.thursday_short'),trans('tripletrax.friday_short'),trans('tripletrax.saturday_short')]
            },
            onClose: function (e) {

                var element = this;
                setTimeout(function () {
                    views.blurDatepicker(element._o.field);
                    if (element._o.field.name !== 'exam_date' && $(element._o.field).is(":focus") && !$(element._o.field).hasClass('tt-no-tab-emulate')) {
                        $(element._o.field).emulateTab();
                    }
                }, 100);
            },
            onOpen: function (e) {

                if ($(this._o.field).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') === '') {
                    this.setDate(moment().toDate());
                    $(this._o.field).val('');
                }

				// if ($(this._o.field).hasClass('tt-view-from-daterange')) {
				// 	var endPicker = $(this._o.field).parents('.row').find('.tt-view-till-daterange').data('picker');
				// 	if (!utils.isUndefined(endPicker)) {
				// 		var startDate = this.getDate();
				// 		this.setStartRange(startDate);
				// 		endPicker.setStartRange(startDate);
				// 		endPicker.setMinDate(startDate);
				// 	}
				// } else if ($(this._o.field).hasClass('tt-view-till-daterange')) {
				// 	var startPicker = $(this._o.field).parents('.row').find('.tt-view-from-daterange').data('picker');
				// 	if (!utils.isUndefined(startPicker)) {
				// 		var endDate = this.getDate();
				// 		startPicker.setEndRange(endDate);
				// 		startPicker.setMaxDate(endDate);
				// 		this.setEndRange(endDate);
				// 	}
				// }
            }
        });

        $(this).data('picker', picker);

        var initValue = $(this).data().initValue;
        if (!utils.isUndefined(initValue) && initValue !== '') {
            if (initValue !== 'not_collected' && initValue !== 'unknown' && initValue !== 'continuing') {
                picker.setDate(utils.stringToDate(initValue));
            } else {
                picker.setDate(null);
                $(this).parents('.input').find('input').val(trans('tripletrax.' + initValue));
            }
        } else {
            picker.setDate(null);
        }

        $(this).addClass("datepicker-container");
    });
}

function setup_widgets_desktop(element) {

    if ($.fn.jarvisWidgets) {

        $(element).find('#widget-grid,#widget-grid-dialog').jarvisWidgets({

            grid: 'article',
            widgets: '.jarviswidget',
            localStorage: true,
            deleteSettingsKey: '#deletesettingskey-options',
            settingsKeyLabel: 'Reset settings?',
            deletePositionKey: '#deletepositionkey-options',
            positionKeyLabel: 'Reset position?',
            sortable: true,
            buttonsHidden: false,
            // toggle button
            toggleButton: true,
            toggleClass: 'fad fa-minus | fad fa-plus',
            toggleSpeed: 200,
            onToggle: function () {
            },
            // delete btn
            deleteButton: true,
            deleteClass: 'fad fa-times',
            deleteSpeed: 200,
            onDelete: function () {
            },
            // edit btn
            editButton: true,
            editPlaceholder: '.jarviswidget-editbox',
            editClass: 'fad fa-cog | fad fa-save',
            editSpeed: 200,
            onEdit: function () {
            },
            // color button
            colorButton: true,
            // full screen
            fullscreenButton: true,
            fullscreenClass: 'fad fa-expand | fad fa-compress',
            fullscreenDiff: 3,
            onFullscreen: function () {
            },
            // custom btn
            customButton: false,
            customClass: 'folder-10 | next-10',
            customStart: function () {
                alert('Hello you, this is a custom button...');
            },
            customEnd: function () {
                alert('bye, till next time...');
            },
            // order
            buttonOrder: '%refresh% %custom% %edit% %toggle% %fullscreen% %delete%',
            opacity: 1.0,
            dragHandle: '> header',
            placeholderClass: 'jarviswidget-placeholder',
            indicator: true,
            indicatorTime: 600,
            ajax: true,
            timestampPlaceholder: '.jarviswidget-timestamp',
            timestampFormat: 'Last update: %m%/%d%/%y% %h%:%i%:%s%',
            refreshButton: true,
            refreshButtonClass: 'fad fa-sync',
            labelError: 'Sorry but there was a error:',
            labelUpdated: 'Last Update:',
            labelRefresh: trans('tripletrax.refresh'),
            labelDelete: 'Delete widget:',
            titleRefresh: trans('tripletrax.refresh'),
            titleCollapse: trans('tripletrax.collapse'),
            titleFullscreen: trans('tripletrax.fullscreen'),
            titleEdit: trans('tripletrax.edit'),
            titleDelete: trans('tripletrax.delete'),
            dataLoadingText: '&nbsp;&nbsp;' + trans('tripletrax.loading') + '...&nbsp;',
            afterLoad: function () {
            },
            rtl: false, // best not to toggle this!
            onChange: function () {

            },
            onSave: function () {

            },
            ajaxnav: $.navAsAjax // declears how the localstorage should be saved (HTML or AJAX page)

        });

    }
}

module.exports.initializeElements = initializeElements;
module.exports.initializeSelect2 = initializeSelect2;
module.exports.initializeDatepicker = initializeDatepicker;
